import React, { Component } from 'react'
import Swal from "sweetalert2";
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import "../../css/pickingSystem-style.css"
import Select from 'react-select';
import { AiOutlineComment, AiOutlineWarning } from "react-icons/ai"
import { FiTrash, FiSave, FiCheckCircle, FiCheckSquare } from "react-icons/fi";
import { FiWifi, FiWifiOff, FiUsers, FiPackage, FiActivity } from "react-icons/fi";
import CustomerListV3 from '../../components/CustomerListV3'
import { getValueCookie } from '../../services/cookieService'
import { create_Delete_Update_Information, getInformationWithData, getInformationWithDataV3, saveJsonData } from '../../services/CABE' // saveJsonData added CUSTFIX-2026-09-16 (parity with SalesOrder.js/InvoiceV3.js)
import { DateFormatMAS90, FormatQueryReturnDateForReport, getActualDateUTC, getDateYearMonthDayDash } from '../../functions/dateFormat';
import LoadingWindow from '../../components/LoadingWindow';
import SalesOrderList from '../../components/SalesOrderList';
import { confirmCloseAlert } from '../../functions/alerts';
import { getPrintHeaderCompany } from '../../functions/companyInformation';
import { OrderPDF } from '../../components/OrderPDF';
import SmallModal from '../../components/SmallModal';
import { pricesFormat } from '../../functions/pricesFormat';
import { DecimalPart, getPriceMargin, getPurePriceMargin, MobileDisp, NumberFormat, OrderArray, validateNumbersForQuantitys } from '../../functions/generalFunctions';
import SearchUPCV3 from './SearchUPCV3';
import { getIndexElement } from '../../functions/searchInObject';
import CatalogueV3 from './CatalogueV3';
import { DownloadOrderPDF } from '../../components/DownloadOrderPDF';
import { prefetchOfflineCatalog, prefetchOfflineCustomers } from '../../services/offlineCatalogCache';
import '../../css/table-font-boost.css';
import TableFontSizeControl from '../../components/TableFontSizeControl';
// Menu
import { Menu } from "../../components/Menu/Menu";

// "Never lose a sales order" post-save check (2026-09-16, client's ask —
// adapted from InvoiceV3.js's validateAndOpenPrint()/
// checkInvoicePersistedCorrectly(), see validateAndPrintSalesOrder()
// below). Rollback switch: set to false to fully disable it — Save and
// Print goes straight back to calling SaveAndPrint() immediately after a
// successful /sales/set/order, no wait, no /sales/get/header+detail check.
//
// DISABLED (2026-09-17, client's ask) — same call as InvoiceV3.js's
// ENABLE_INVOICE_PERSISTENCE_CHECK: turned off here instead of deleting the
// feature, so Save and Print behaves exactly like it did before
// 2026-09-16 while the code stays in place to fix and re-enable later.
const ENABLE_SALES_ORDER_PERSISTENCE_CHECK = false;
// Salespersons excluded from this check (matched against the CURRENT
// session's getValueCookie('SalesPerson'), not the order's own
// SalespersonNo) — client's ask: roll this out salesperson-by-salesperson
// instead of all-at-once, starting with 'AM' excluded for controlled
// testing. Add/remove codes here as the rollout widens.
const SALES_ORDER_PERSISTENCE_CHECK_EXCLUDED_SALESPERSONS = ['AM'];

/**
 * SalesOrderV3 — clone of SalesOrderV2 for the standardized pricing project (2026-08).
 *
 * ONLY the pricing logic changes here. Everything else (customer selection, packing,
 * printing, balance modal, offline cache) is unchanged from V2 — see SalesOrderV2.js
 * for that logic if you're debugging something unrelated to price.
 *
 * What's different from V2:
 *   - Catalogue/UPC search are CatalogueV3.js / SearchUPCV3.js — built from
 *     scratch (2026-08-13), not clones of CatalogueV2/SearchUPC. Those shared
 *     originals each had their own duplicate Altitude markup calculation (a
 *     3rd formula, different from both this page's old one and the backend's —
 *     confirmed 2026-08-13) and made a live, unguarded WS call for scan-and-add
 *     pricing. The V3 versions read only from product_pricing via RDS-only v3
 *     endpoints (see salesOrderCatalog.ts) — no MAS90/WS call anywhere, and the
 *     price shown while browsing is the exact price that lands in the cart, so
 *     there's no "why did it change when I added it" moment for the user.
 *   - On mount, still loads the full product_pricing table for this session's
 *     company (/v3/pricing/map) into `pricingMap` — kept as a defensive
 *     safety net via applyStandardPricing()/`_pricingApplied`, in case a line
 *     ever arrives without pricing already attached (CatalogueV3/SearchUPCV3
 *     normally attach it directly via buildCartLine.js, so this rarely fires).
 *   - Price editing enforces minPrice from product_pricing as a hard floor
 *     for everyone, admin included (2026-08-19/20 — "never lose money", not
 *     a negotiation range like V2's ad-hoc Altitude-only minimum). No max
 *     ceiling (2026-08-20, client's ask — "no se usará").
 *   - Below-minimum exception (migration 017/019): some products are sold at
 *     Level 3 or Level 4 below the normal minimum by internal company
 *     arrangement. item.minPrice from /v3/pricing/map is already the fully
 *     resolved floor (2026-08-27, simplified — the backend picks between
 *     the normal minimum and cost/0.95 for a flagged tier, never raw cost)
 *     — priceFloorFor() below just returns it, used by both
 *     checkPriceBounds() and the "Minimum: $X" badge under the Unit Price
 *     input. Still never below cost + 5% — a sale can never hit zero margin.
 *   - After a successful save, calls /v3/pricing/record-sale to snapshot
 *     cost/standardPrice/finalPrice onto the SO's detail rows (migration 012).
 *     This is a second, separate call — /sales/set/order (v2) itself is untouched.
 *   - Items with no row yet in product_pricing show a "no standard price set"
 *     warning badge instead of a silent/wrong price — visibility was the whole
 *     point of this project.
 */
export default class SalesOrderV3 extends Component {
  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
    // Validate if new order was created
    const newSOstatus = localStorage.getItem('isNotNewSOV3');

    this.state = {
      disable: false,
      isSaving: false,
      isInputFocused: false,
      ConfirmSave: 0,
      ProductList: [],
      ProductsForAltitude: [],
      Products: [],
      // OFFLINE-2026-09-29 — this FAB/panel existed before but its 3 status
      // fields were never reassigned anywhere (dead UI, client mistook it for
      // the new offline feature — see runOfflineSync() below). Now driven by
      // the real prefetch calls; syncImagesStatus/its row removed since Phase
      // 1 never built image caching — showing a fake "done" for that would be
      // misleading. lastXCount populate once a real sync actually fetches
      // something, so the panel can show "N items ready" instead of just ✓.
      syncItemsStatus: "pending",
      syncCustomersStatus: "pending",
      lastCatalogSyncCount: null,
      lastCustomersSyncCount: null,
      // TABLEFONTBOOST-2026-10-01 — same as InvoiceV3.js's own field, see
      // that file's comment + css/table-font-boost.css for the full reasoning.
      tableFontScale: (() => {
        const saved = parseFloat(localStorage.getItem('salesOrderV3TableFontScale'))
        return (!isNaN(saved) && saved >= 0.85 && saved <= 1.4) ? saved : 1
      })(),
      // LONGDESC-2026-10-01 — same pattern as InvoiceV3.js/WarehousePicking.js:
      // caches /v3/salesorder/catalog by itemCode so the cart table (below)
      // can show the real long description for items loaded from an
      // EXISTING/saved order (those only carry the short ItemCodeDesc from
      // SalesOrderDetail — items added fresh via CatalogueV3.js already get
      // it baked in by buildCartLine.js, so this only matters for reopened
      // orders, but it's needed there).
      Catalog: [],
      SalesOrder: {
        Customer: {
          AddressLine1: '',
          City: '',
          CustomerName: '',
          CustomerNo: '',
          EmailAddress: '',
          PriceLevel: undefined,
          SalespersonNo: '',
          State: '',
          TelephoneNo: '',
          ZipCode: '',
          uniqueTrack: '',
        },
        NoOrder: '',
        Type: 'S',
        TotalQuantityOrdered: 0,
        TotalCost: 0,
        TotalWeight: 0,
        Date: getDateYearMonthDayDash(),
        Warehouse: '000',
        Packing: null,
        WeightOption: null,
        MAS90Status: 0,
        TotalLines: 0,
        Duplicate: false,
        status: null,

      },
      Balance: {
        // Two lists (2026-09-02, client's ask) — CustomerInvoices is the
        // actually-correct one (this customer's own CustomerNo);
        // SalespersonInvoices is the original salesperson-wide informational
        // list (was HeaderBalance) — see CustomerListV3.js's selectCustomer.
        CustomerInvoices: [],
        SalespersonInvoices: [],
        TermsCode: '',
        TotalBalance: 0,
        CustomerBalance: 0,
        SelectedInvoice: '',
        Detail: []
      },

      companyPrintHeader: getPrintHeaderCompany(),
      showModal1: false,
      confirmMargin: false,
      NotZeroUnitPrice: true,
      selectOptions1: [

        { value: 'Transparent Stretch Wrap', label: 'Transparent Stretch Wrap' },
        { value: 'Black Stretch Wrap', label: 'Black Stretch Wrap' },
        { value: 'Not Packing (Customer Collect) ', label: 'Not Packing (Customer Collect)' }
      ],
      selectOptions2: [
        { value: '003', label: 'B&B Miami Warehouse Price Level 4' },//4
        { value: '000', label: 'Mayaland Atlanta Warehouse Price Level 3' }//5
      ],
      selectOptions3: [

        { value: 'Weighed', label: 'Weighed' },
        { value: 'No need to be Weighed', label: 'No need to be Weighed' }
      ],
      enableEdit: false,
      isMayalandOrder: true,
      isNotNewSO: newSOstatus === 'true',
      newSalesOrder: false,
      isOnline: navigator.onLine,
      wasOffline: false,
      showSyncPanel: false,
      selectedWarehouse: null,
      selectedPacking: null,
      selectedWeight: null,
      // Standardized pricing (2026-08 project) — itemCode -> {cost, standardPrice, minPrice, maxPrice, marginPercent}
      pricingMap: {},
      pricingLoaded: false,
      // Tiered customer pricing (2026-08-19) — resolved tier for the selected
      // customer (default 1), returned alongside pricingMap by /v3/pricing/map.
      customerPriceLevel: 1,
    }
    this.toggleSyncPanel = this.toggleSyncPanel.bind(this);
  }

  static SO_CACHE_KEY = 'offline_sales_order_v3';
  __soSaveTimer = null;
  __prevSOSerialized = '';

  // Cambiar el status para el panel de status de sincronizacion
  toggleSyncPanel() {
    this.setState({ showSyncPanel: !this.state.showSyncPanel });
  }

  // TABLEFONTBOOST-2026-10-01
  setTableFontScale = (scale) => {
    this.setState({ tableFontScale: scale })
    localStorage.setItem('salesOrderV3TableFontScale', String(scale))
  }

  // LONGDESC-2026-10-01 — same fetch/cache pattern as InvoiceV3.js's own
  // fetchCatalogV3()/getItemLongDescription() (itself copied from
  // Warehouse/PickingSystem/WarehousePicking.js — see that file for the
  // original reasoning). Kept as its own copy here rather than a shared
  // import, same isolation call this session already made for
  // offlineCatalogCache.js: each page owns its own cache instance.
  async fetchCatalogV3() {
    if (this.state.Catalog && this.state.Catalog.length > 0) {
      return this.state.Catalog
    }

    const idCompany = getValueCookie('CompanyId')
    const pageSize = 200
    const MAX_PAGES = 500
    let allItems = []
    let page = 1
    let complete = false

    while (page <= MAX_PAGES) {
      const resp = await getInformationWithDataV3('/v3/salesorder/catalog', { idCompany, page, pageSize })
      if (!resp || !resp.status || resp.status.code !== 1 || !Array.isArray(resp.data)) {
        break
      }
      if (resp.data.length === 0) {
        complete = true
        break
      }
      allItems = allItems.concat(resp.data)
      const total = Number(resp.total)
      if (resp.data.length < pageSize || (!isNaN(total) && allItems.length >= total)) {
        complete = true
        break
      }
      page++
    }

    if (complete) {
      this.setState({ Catalog: allItems })
    }
    return allItems
  }

  getItemLongDescription(element) {
    const catalogIndex = getIndexElement(this.state.Catalog, 'itemCode', element.itemCode)
    const longDescription = catalogIndex !== -1 ? this.state.Catalog[catalogIndex].longDescription : null
    if (longDescription) return longDescription
    return (element.completeDesc && element.completeDesc !== 'null') ? element.completeDesc : element.abbreviatedDesc
  }

  // OFFLINE-2026-09-29 — the actual sync behind the FAB panel above. Runs
  // automatically on page load (componentDidMount) and again on demand from
  // the panel's "Sync now" button (force=true, bypasses the cache TTL) —
  // client explicitly asked for a visible, intuitive way to trigger/see this
  // instead of it only happening implicitly the first time the Catalogue
  // modal is opened.
  runOfflineSync = async (force) => {
    if (!navigator.onLine) return
    this.setState({ syncCustomersStatus: 'started', syncItemsStatus: 'started' })
    const idCompany = getValueCookie('CompanyId')
    const [catalogResult, customersResult] = await Promise.all([
      prefetchOfflineCatalog(idCompany, force),
      prefetchOfflineCustomers(idCompany, getValueCookie('SalesPerson'), getValueCookie('TypeUser'), force),
    ])
    this.setState({
      syncItemsStatus: catalogResult.reason === 'error' ? 'pending' : 'done',
      syncCustomersStatus: customersResult.reason === 'error' ? 'pending' : 'done',
      lastCatalogSyncCount: catalogResult.synced ? catalogResult.count : this.state.lastCatalogSyncCount,
      lastCustomersSyncCount: customersResult.synced ? customersResult.count : this.state.lastCustomersSyncCount,
    })
  }

  /** Guarda el SalesOrder actual al cache (localStorage) */
  saveSalesOrderToCache = () => {
    try {
      const json = JSON.stringify(this.state.SalesOrder);
      localStorage.setItem(SalesOrderV3.SO_CACHE_KEY, json);
    } catch (err) {
      console.error('saveSalesOrderToCache failed:', err);
    }
  };

  /** Debounce para evitar escribir en cada cambio micro */
  scheduleSaveSalesOrder = () => {
    clearTimeout(this.__soSaveTimer);
    this.__soSaveTimer = setTimeout(this.saveSalesOrderToCache, 300);
  };

  /** Carga del cache y fusiona con el estado actual (mantiene defaults) */
  loadSalesOrderFromCache = () => {
    try {
      const raw = localStorage.getItem(SalesOrderV3.SO_CACHE_KEY);
      if (!raw) return;

      const cached = JSON.parse(raw);
      if (!cached || typeof cached !== 'object') return;

      // Merge conservando tus defaults actuales
      const merged = {
        ...this.state.SalesOrder,
        ...cached,
        Customer: {
          ...this.state.SalesOrder.Customer,
          ...(cached.Customer || {}),
        },
      };

      this.setState({ SalesOrder: merged }, () => {
        // guarda la huella para que el primer didUpdate no vuelva a guardarlo
        this.__prevSOSerialized = JSON.stringify(this.state.SalesOrder);
      });
    } catch (err) {
      console.error('loadSalesOrderFromCache failed:', err);
    }
  };

  /** Limpia el cache (llámala cuando completes y envíes la SO al backend) */
  clearSalesOrderCache = () => {
    Swal.fire({
      title: 'Before to continue',
      text: "Are you sure to clear the Sales Order cache? This will remove the order data.",
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Yes, clear',
      cancelButtonText: 'No, cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        localStorage.removeItem(SalesOrderV3.SO_CACHE_KEY);
        localStorage.removeItem('SalesOrderSaveV3');
        localStorage.removeItem('isNotNewSOV3');
        this.clearSalesOrder();
      }
    })
  }

  // Handle online flag
  handleOnline = () => {
    this.setState({ isOnline: true });
    console.log("Conectado a internet");
  };

  // Handle offline flag
  handleOffline = () => {
    this.setState({ isOnline: false, wasOffline: true });
    console.log("Sin conexión a internet");
  };


  setupBeforeUnloadListener = () => {
    if (this.state.Products.length > 0) {
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        ev.returnValue = '';
        return this.doSomethingBeforeUnload();
      });
    }
  };

  async getNewCorrelativeSalesOrder() {
    if (!this.state.wasOffline) {
      this.clearSalesOrder();
    }

    const data = {
      type: 'SalesOrder',
      idCompany: getValueCookie('CompanyId')
    };

    const result = await getInformationWithData('/sales/get/correlative', data);
    if (result.status.code === 1) {
      const temporal = this.state.SalesOrder
      temporal.NoOrder = (getValueCookie('CompanyId') === '6' ? 'AL' : 'PM') + result.data[0].correlative;
      this.setState({ SalesOrder: temporal });
    }
  }

  async offlineNewOrder() {
    let temporal = {
      ConfirmSave: 0,
      confirmMargin: false,
      NotZeroUnitPrice: true,
      Customer: {
        AddressLine1: '',
        City: '',
        CustomerName: '',
        CustomerNo: '',
        EmailAddress: '',
        PriceLevel: undefined,
        SalespersonNo: '',
        State: '',
        TelephoneNo: '',
        ZipCode: '',
        uniqueTrack: '',
      },
      TotalLines: 0,
      NoOrder: '',
      Type: 'S',
      TotalQuantityOrdered: 0,
      TotalCost: 0,
      TotalWeight: 0,
      Date: getDateYearMonthDayDash(),
      Warehouse: '000',
      Packing: null,
      WeightOption: null,
      MAS90Status: 0,
      Duplicate: false,
    };
    temporal.NoOrder = 'OFFLINE';
    this.setState({ SalesOrder: temporal, offlinePendingWork: true });
  }

  valueRadioButton = async e => {
    let stat = e.target.value
    const temporal = this.state.SalesOrder
    temporal.Type = stat
    this.setState({ SalesOrder: temporal })
  }

  calculateTotals() {
    let totalQuantity = 0
    let totalCost = 0
    let totalWeight = 0
    let totalPrice = 0
    const temporal = this.state.Products
    const temporal2 = this.state.SalesOrder

    for (const item of temporal) {

      totalPrice += Number(item.LastTotalUnitCost) * Number(item.quantityOrdered)
      totalQuantity += Number(item.quantityOrdered)
      totalCost += Number(item.totalCost)
      totalWeight += Number(item.quantityOrdered) * Number(item.ShipWeight)
    }

    temporal2.TotalQuantityOrdered = totalQuantity
    temporal2.TotalCost = totalCost
    temporal2.TotalWeight = totalWeight
    temporal2.Customer.uniqueTrack = getPriceMargin(totalCost, totalPrice, temporal2.Customer.PriceLevel)
    this.setState({ SalesOrder: temporal2 })
    this.AutoSave()
  }

  async getItemList() {
    const data = {
      companyId: "3"
    }
    try {
      let response = await getInformationWithData('/Items/getListV2', data);
      this.setState({ ProductList: response.data })
    } catch (error) {
      console.log(error)
    }
  }

  /**
   * Loads the full standardized price table for this session's company —
   * once on mount, and again every time the selected customer changes (see
   * componentDidUpdate). itemCode -> {cost, standardPrice, minPrice, maxPrice}.
   * Replaces V2's setAltPrice() (live MAS90 markup calc) as the price source.
   *
   * Tiered customer pricing (2026-08-19): passing customerNo makes
   * `standardPrice` resolve to that customer's tier (level1/2/3Price via
   * customer_price_level, default level 1) instead of the flat legacy
   * standardPrice column — see productPricing.ts's getMap header comment.
   * Existing cart lines get re-priced too (applyStandardPricing below), since
   * they were only marked _pricingApplied under the PREVIOUS customer's tier.
   */
  async loadPricingMap() {
    try {
      const idCompany = getValueCookie('CompanyId')
      const customerNo = this.state.SalesOrder.Customer.CustomerNo
      const resp = await getInformationWithDataV3('/v3/pricing/map', { idCompany, customerNo })
      const map = {}
      if (resp && resp.status && resp.status.code === 1 && Array.isArray(resp.data)) {
        for (const row of resp.data) {
          map[row.itemCode] = {
            cost: row.cost !== null && row.cost !== undefined ? Number(row.cost) : null,
            standardPrice: row.standardPrice !== null && row.standardPrice !== undefined ? Number(row.standardPrice) : null,
            minPrice: row.minPrice !== null && row.minPrice !== undefined ? Number(row.minPrice) : null,
            maxPrice: row.maxPrice !== null && row.maxPrice !== undefined ? Number(row.maxPrice) : null,
            level1Price: row.level1Price !== null && row.level1Price !== undefined ? Number(row.level1Price) : null,
            allowBelowCost: !!row.allowBelowCost,
          }
        }
      }
      const customerPriceLevel = resp && resp.priceLevel ? Number(resp.priceLevel) : 1
      this.setState({ pricingMap: map, pricingLoaded: true, customerPriceLevel, Products: this.state.Products.map((p) => ({ ...p, _pricingApplied: false })) }, () => this.applyStandardPricing())
    } catch (error) {
      console.error('loadPricingMap failed:', error)
      // Fail open on pricingLoaded so applyStandardPricing can still run (it
      // will just find nothing in the map and flag every item as unpriced,
      // which is the correct, visible behavior when the map can't load).
      this.setState({ pricingLoaded: true })
    }
  }

  /**
   * Overwrites the price of any cart item not yet marked `_pricingApplied`.
   * CatalogueV3/SearchUPCV3 already attach the correct price via
   * buildCartLine.js at add-time, but this is ALSO the mechanism that
   * re-prices EXISTING cart lines when the customer changes mid-order
   * (loadPricingMap() resets every line's `_pricingApplied` to false right
   * before calling this, so every line gets re-evaluated against the new
   * customer's tier). Idempotent via the marker, so it's safe to call from
   * componentDidUpdate on every render without side effects once a line is
   * already priced.
   *
   * refreshInputs() (2026-08-21, client's ask — "los productos se quedan con
   * los precios del nivel anterior y no se actualizan"): the Unit Price
   * `<input>` is uncontrolled (`defaultValue`), so updating `UnitPrice` here
   * only fixes the row's internal state/total — the visible input keeps
   * showing the old typed value until something writes the DOM directly,
   * same class of bug fixed elsewhere in this file (checkPriceBounds'
   * clampTo, removeProduct). Without this, a customer change silently
   * recalculates the grand total correctly while every row still LOOKS
   * unpriced.
   */
  applyStandardPricing() {
    if (!this.state.pricingLoaded) return
    const pricingMap = this.state.pricingMap
    let changed = false
    const updated = this.state.Products.map((item) => {
      if (item._pricingApplied) return item
      changed = true
      const pricing = pricingMap[item.itemCode]
      if (!pricing || pricing.standardPrice === null) {
        // No standardized price configured yet for this item — leave the price
        // as-is but flag it, so the user sees it's not bounded by min/max
        // instead of silently trusting an unconfigured price.
        return { ...item, _pricingApplied: true, _noPricingConfigured: true }
      }
      const unitPrice = pricing.standardPrice
      return {
        ...item,
        UnitPrice: unitPrice,
        totalCost: unitPrice * Number(item.quantityOrdered || 0),
        minPrice: pricing.minPrice,
        maxPrice: pricing.maxPrice,
        level1Price: pricing.level1Price,
        allowBelowCost: pricing.allowBelowCost,
        costAtSale: pricing.cost,
        standardPriceAtSale: pricing.standardPrice,
        finalPrice: unitPrice,
        _pricingApplied: true,
        _noPricingConfigured: false,
      }
    })
    if (changed) {
      this.setState({ Products: updated }, () => {
        this.calculateTotals()
        this.refreshInputs()
      })
    }
  }

  /**
   * Replaces V2's checkMinPrice(). Enforces a price floor from product_pricing
   * — matches the client's ask: a salesperson can never sell below the
   * minimum for the company they're logged into.
   *
   * Floor (2026-08-19, corrected 2026-08-20): the item's minPrice for THIS
   * session's company — not level1Price. An earlier version used level1Price
   * as the floor, but that's just the default/standard price, not a real
   * per-company floor. minPrice is now the actual computed rule from Price
   * Management (master: cost/0.95; distributor: derived from the master's
   * own row — see productPricing.ts's upsert), which is exactly "the
   * minimum for the company I'm logged into" the client asked for. Falls
   * back to level1Price only if minPrice was never configured for this item
   * (older items that haven't gone through the new pricing hierarchy yet).
   * This is a hard "never lose money" rule, never skippable — not even for
   * admin.
   *
   * Max price removed entirely (2026-08-20, client's ask — "no se usará"):
   * no ceiling check anymore, only the floor.
   */
  /**
   * Below-minimum exception (migration 017/019) — shared by
   * checkPriceBounds() and the "Minimum: $X" badge below the Unit Price
   * input, so both always agree on the same floor.
   *
   * Simplified 2026-08-27 (client's ask — "no debemos dejar vender nada al
   * costo... debe ser costo + 5%"): item.minPrice from /v3/pricing/map is
   * now ALREADY the fully-resolved floor — the backend itself picks between
   * the normal minimum and the cost/0.95 exception based on the customer's
   * tier and that tier's allowBelowCost flag (see productPricing.ts's
   * getMap header comment). No more client-side branching on
   * allowBelowCost/costAtSale here — that duplicated the same rule in two
   * places and is exactly what let the exception drop all the way to raw
   * cost before this fix. allowBelowCost is still used elsewhere purely for
   * the "special pricing" wording, not for computing the number itself.
   */
  priceFloorFor(item) {
    return (item.minPrice !== undefined && item.minPrice !== null) ? item.minPrice : item.level1Price
  }

  checkPriceBounds(temporal, newValue) {
    const newPrice = Number(newValue.target.value)
    const min = this.priceFloorFor(temporal)
    // The Unit Price <input> is uncontrolled (defaultValue, not value) — same
    // reason onTarget's own quantity clamp writes the DOM directly. Without
    // this, the field kept showing whatever the user typed even after state
    // was corrected (confirmed 2026-08-19: alert said $11 minimum, field
    // still showed 9). Always recalculates totals too — checkPriceBounds
    // returning false short-circuits onTarget's own calculateTotals() call,
    // which was leaving the grand total stale after every clamp.
    const inputId = newValue.target.id
    const clampTo = (bound) => {
      const totalCost = temporal.quantityOrdered * bound
      this.setState((prevState) => ({
        Products: prevState.Products.map((item) =>
          item.itemCode === temporal.itemCode
            ? { ...item, UnitPrice: Number(bound.toFixed(2)), totalCost: totalCost, finalPrice: Number(bound.toFixed(2)) }
            : item
        )
      }), () => {
        const el = document.getElementById(inputId)
        if (el) el.value = Number(bound.toFixed(2)).toFixed(2)
        this.calculateTotals()
      })
    }

    if (min !== undefined && min !== null && newPrice < min) {
      // Auto-correct to the customer's price level (catalog price), not the
      // bare floor (2026-08-21, client's ask) — more useful to a salesperson
      // than snapping to the legal minimum. Falls back to the floor itself
      // if the tier price isn't available or is somehow below it.
      const target = (temporal.standardPriceAtSale !== undefined && temporal.standardPriceAtSale !== null && temporal.standardPriceAtSale >= min)
        ? temporal.standardPriceAtSale
        : min
      clampTo(target)
      alert(`${temporal.allowBelowCost ? 'The minimum (special pricing)' : 'The minimum price'} for this product has been exceeded. Price reset to the customer's price level: $${NumberFormat(pricesFormat(target))}`)
      return false
    }
    return true
  }

  onTargetChange(e, product) {
    let newPrice = e.target.value;
    this.setState((prevstate) => {
      const updatedProducts = prevstate.Products.map((item) => {
        if (item.itemCode === product.itemCode) {
          return { ...item, UnitPrice: newPrice };
        }
        return item
      });
      return { Products: updatedProducts }
    })
  }

  onTarget = async (e, item) => {
    const temporal = this.state.Products
    const ident = e.target.id.split('_')
    const index = temporal.indexOf(item)

    if (index !== -1) {
      if (ident[0] === "quantityOrderedSalesOrder") {
        let quant = Number(e.target.value)

        if (!validateNumbersForQuantitys(quant)) {
          let parteDecimal = 1 - DecimalPart(quant)
          quant += parteDecimal
          document.getElementById(e.target.id).value = quant
        }

        // Hard minimum of 1 (2026-08-19) — this field edits an existing cart
        // line, it doesn't remove one. Dropping to 0 here used to silently
        // zero out the line without deleting it; removal must go through the
        // trash button instead, which actually takes the row out of the cart.
        if (quant < 1) {
          quant = 1
          document.getElementById(e.target.id).value = quant
          alert('La cantidad mínima es 1. Para eliminar el producto usa el botón de la papelera.')
        }

        temporal[index].quantityOrdered = Number(quant)
        temporal[index].totalCost = (Number(quant) * Number(temporal[index].UnitPrice))
        this.setState({ Products: temporal, ConfirmSave: 0 })
        this.calculateTotals()
      } else if (ident[0] === "unitPriceSalesOrder") {
        temporal[index].UnitPrice = Number(e.target.value)
        temporal[index].totalCost = (Number(e.target.value) * Number(temporal[index].quantityOrdered))
        temporal[index].finalPrice = temporal[index].UnitPrice
        if (getValueCookie('CompanyId') === '6') {
          temporal[index].Comment = "BOX:" + this.state.SalesOrder.Customer.CustomerName
          temporal[index].PureMargin = getPurePriceMargin(temporal[index].UnitPrice, temporal[index].unitCost)
        }
        // Standardized pricing (2026-08) — the minPrice floor (2026-08-19) is
        // enforced for EVERYONE including admin, no bypass — it's a "never
        // lose money" rule, not a negotiation range. Max price removed
        // entirely (2026-08-20, client's ask — "no se usará").
        if (this.checkPriceBounds(temporal[index], e)) {
          this.setState({ Products: temporal, ConfirmSave: 0 })
          this.calculateTotals()
        }
      }
    }
    await this.AutoSave()
    this.setState({ isInputFocused: false });
  }

  checkInputFocus = () => {
    this.setState({ isInputFocused: true });
  }

  clearSalesOrder() {
    const clear = {
      ConfirmSave: 0,
      confirmMargin: false,
      NotZeroUnitPrice: true,
      Customer: {
        AddressLine1: '',
        City: '',
        CustomerName: '',
        CustomerNo: '',
        EmailAddress: '',
        PriceLevel: undefined,
        SalespersonNo: '',
        State: '',
        TelephoneNo: '',
        ZipCode: '',
        uniqueTrack: '',
      },
      TotalLines: 0,
      NoOrder: '',
      Type: 'S',
      TotalQuantityOrdered: 0,
      TotalCost: 0,
      TotalWeight: 0,
      Date: getDateYearMonthDayDash(),
      Warehouse: '000',
      Packing: null,
      WeightOption: null,
      MAS90Status: 0,
      Duplicate: false,
    }
    this.setState({ SalesOrder: clear, Products: [], enableEdit: false })
    localStorage.removeItem('SalesOrderSaveV3')
  }

  addComentary(item) {
    let comm = item.Comment
    Swal.fire({
      title: 'Product: ' + item.itemCode,
      html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfSalesOrder' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
      backdrop: true,
      showCancelButton: true,
      confirmButtonText: 'Save Commentary',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const temporal = this.state.Products
        const index = temporal.indexOf(item)
        if (index !== -1) {
          const coment = Swal.getPopup().querySelector('#comentOfSalesOrder').value
          temporal[index].Comment = coment
          this.setState({ Products: temporal })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    })
    this.AutoSave()
  }

  removeProduct(item) {
    let temporal = this.state.Products
    const index = temporal.indexOf(item)

    if (index !== -1) {
      temporal[index].quantityOrdered = 0
      temporal[index].totalCost = 0
      temporal[index].Visible = 0

      for (let a = 0; a < temporal.length; a++) {
        document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
        // .toFixed(2) (2026-08-20) — writing the raw number here (e.g. 12.5)
        // showed 1 decimal instead of 2, since this input is uncontrolled and
        // nothing else re-formats it after this direct DOM write.
        document.getElementById("unitPriceSalesOrder_" + a).value = Number(temporal[a].UnitPrice).toFixed(2)
      }

      this.setState({ Products: temporal })
      this.calculateTotals()
    }
    this.AutoSave()
  }

  refreshInputs() {
    const temporal = this.state.Products
    for (let a = 0; a < temporal.length; a++) {
      document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
      // .toFixed(2) (2026-08-20) — same fix as removeProduct() above.
      document.getElementById("unitPriceSalesOrder_" + a).value = Number(temporal[a].UnitPrice).toFixed(2)
    }
  }

  AsignLineSequence() {
    const head = this.state.SalesOrder
    if (getValueCookie('CompanyId') === '6') {
      const temporal = OrderArray(JSON.parse(JSON.stringify(this.state.Products)), 'IdCompany', true)

      let confirmMargin = false
      let NotZeroUnitPrice = true
      let count = 1
      let activeLines = 0
      for (const item of temporal) {
        item.LineSequence = count
        item.quantityShipped = 0
        count++
        if (!confirmMargin) {
          confirmMargin = item.PureMargin > 20 ? false : true
        }
        if (item.UnitPrice <= 0 && item.Visible === 1) {
          NotZeroUnitPrice = false
        }
        if (item.Visible !== 0) {
          activeLines++
        }
      }

      head.TotalLines = activeLines
      this.setState({ confirmMargin: confirmMargin, NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
      return temporal
    } else {
      const temporal = this.state.Products
      let NotZeroUnitPrice = true
      let count = 1
      let activeLines = 0
      for (const item of temporal) {
        item.LineSequence = count
        item.quantityShipped = 0
        count++
        if (item.UnitPrice <= 0 && item.Visible === 1) {
          NotZeroUnitPrice = false
        }
        if (item.Visible !== 0) {
          activeLines++
        }
      }
      head.TotalLines = activeLines
      this.setState({ NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
      return temporal
    }
  }

  detailToPrint() {
    let items = []
    this.state.Products.forEach(element => {
      if (element.Visible === 1) {
        // LONGDESC-2026-10-01 — same gap as the on-screen cart table above
        // (items loaded from an existing/saved order only carry the short
        // ItemCodeDesc, no long description baked in) — the printed Sales
        // Order PDF (below) reads element.abbreviatedDesc directly via
        // headerBodyTable, so it needs the same resolution before printing.
        element.abbreviatedDesc = this.getItemLongDescription(element)
        items.push(element)
      }
    });
    return items
  }

  /**
   * 2026-09-02 fix (client-reported near-miss, product INCP1002): this used
   * to price the Mayaland->Altitude intercompany line at
   * `element.LastTotalUnitCost / 0.95`, where LastTotalUnitCost came from
   * whatever was on the cart line — ultimately `itemCatalogue` (a
   * nightly-synced RDS mirror of MAS90's raw cost, never touched by the
   * 2026-08-27 distributor-staleness fix). Confirmed live: itemCatalogue had
   * $37.03 for this item while product_pricing (the fixed, always-live
   * source getMap already uses everywhere else) had $42.19 — a real,
   * ongoing gap, not a one-off. Now fetches Mayaland's own live cost from
   * /v3/pricing/map (idCompany=3) right before pricing the companion order,
   * same source/same formula getMap uses, instead of trusting anything
   * already sitting on the cart line.
   */
  async updateMayalandSO(altitudeSO) {
    let mayalandTemporal = altitudeSO;
    mayalandTemporal.idCompany = "3"
    mayalandTemporal.company = 'Mayaland Atlanta'
    mayalandTemporal.Customer.CustomerNo = '0016027';

    const mayalandCostMap = await this.loadMayalandCostMap();
    mayalandTemporal.Detail = this.updateAltitudePrices(mayalandTemporal.Detail, mayalandCostMap);

    await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
  }

  async loadMayalandCostMap() {
    const costMap = {}
    try {
      const resp = await getInformationWithDataV3('/v3/pricing/map', { idCompany: '3', customerNo: '0016027' })
      if (resp && resp.status && resp.status.code === 1 && Array.isArray(resp.data)) {
        for (const row of resp.data) {
          costMap[row.itemCode] = row.cost !== null && row.cost !== undefined ? Number(row.cost) : null
        }
      }
    } catch (error) {
      console.error('loadMayalandCostMap failed:', error)
    }
    return costMap
  }

  updateAltitudePrices(productList, mayalandCostMap) {
    productList.forEach(element => {
      const cost = mayalandCostMap ? mayalandCostMap[element.itemCode] : null;
      if (cost === null || cost === undefined) {
        console.error(`[updateAltitudePrices] No live Mayaland cost for ${element.itemCode} — leaving UnitPrice untouched, needs manual review.`);
        return;
      }
      const altitudePrice = cost / 0.95;
      element.UnitPrice = Number(altitudePrice.toFixed(2))
    });
    return productList;
  }

  async checkSalesOrderStatus(SONumber) {
    const data = {
      SalespersonNo: getValueCookie('SalesPerson'),
      idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
    }
    const response = await getInformationWithData('/sales/get/header', data);
    const salesOrderList = response.data;

    const getSalesOrder = salesOrderList.find(obj => obj.SalesOrderNo === SONumber)
    if (getSalesOrder) {
      return getSalesOrder.Status;
    }
    return 0
  }

  /**
   * Removes duplicate itemCode rows from a Products array, keeping the FIRST
   * occurrence and dropping the rest (2026-08-19). Any duplicate here is a
   * bug artifact, never a legitimate second line: adding the same item again
   * always bumps the existing row's quantity instead of creating a new one
   * (see CatalogueV3.js's setQuantity / SearchUPCV3.js's searchAndAdd) — a
   * duplicate can still slip through a race between those two components
   * (their in-flight locks are per-component, not shared) or from a stale
   * cached SO saved before those locks existed. Client reported a real order
   * (AL64684) where every line was saved twice — see salesOrderIntegrity.ts
   * header for the full incident and the server-side safety net this pairs
   * with. Does NOT merge quantities (an earlier version did) — deleting is
   * safe precisely because a duplicate is never a real second demand for the
   * item, only ever a race/cache artifact.
   */
  removeDuplicateProducts(products) {
    const seen = new Set()
    const removedCodes = []
    const cleaned = []
    for (const item of products) {
      if (seen.has(item.itemCode)) {
        removedCodes.push(item.itemCode)
        continue
      }
      seen.add(item.itemCode)
      cleaned.push(item)
    }
    return { cleaned, removedCodes }
  }

  /** Runs removeDuplicateProducts and, if it found anything, warns + alerts the user. */
  validateNoDuplicateProducts(products) {
    const { cleaned, removedCodes } = this.removeDuplicateProducts(products)
    if (removedCodes.length > 0) {
      console.warn('[SalesOrderV3] Duplicate line items removed:', removedCodes)
      confirmCloseAlert('incorrect', `Se detectaron productos duplicados en la orden y se eliminó la fila repetida de: ${removedCodes.join(', ')}. Se conservó la primera fila de cada uno.`)
    }
    return cleaned
  }

  /**
   * Server-side safety net — runs right after /sales/set/order succeeds.
   * Never blocks the save flow: the SO is already saved either way.
   */
  async dedupeOrderOnServer(temporal) {
    try {
      await getInformationWithDataV3('/v3/salesorder/dedupe', {
        orderNo: temporal.NoOrder,
        idCompany: temporal.idCompany,
      })
    } catch (error) {
      console.error('dedupeOrderOnServer failed (SO itself was already saved):', error)
    }
  }

  /**
   * Writes to document_audit_trail — AFTER /sales/set/order (v2, untouched)
   * already saved the order. performedBy is derived server-side from the JWT,
   * not sent from here; salespersonNo IS sent from here because it's the value
   * that later gets silently overwritten (sales_orders_aws_v2.salesperson_no
   * is a single mutable column) — capturing it at creation time is the whole
   * point of this table. Never blocks the save flow, same as
   * dedupeOrderOnServer/recordPriceSnapshot above.
   *
   * action (fixed 2026-08-26 — client's ask, for the Traceability V3 list
   * report): this used to hardcode 'created' regardless of context, even
   * though both call sites (the Save button) handle editing an EXISTING SO
   * just as often as creating a brand new one — every edit was silently
   * logged as if it were the original creation. `isNotNewSO` is the same
   * flag this page already uses elsewhere (e.g. the Type radio buttons) to
   * know whether the currently-loaded SalesOrder came from an existing
   * record. Only affects logging going forward — past saves that were
   * wrongly logged as 'created' can't be reclassified retroactively, since
   * the mistake is already baked into those rows.
   */
  // CUSTFIX-2026-09-16 — added `details: {customerNo, customerName}` on the
  // 'created' row. This table is append-only (never edited later), so the
  // customer captured HERE at creation time becomes a frozen, trustworthy
  // reference — independent of any later WS-based customer lookup (in
  // Picking, Invoicing, or anywhere else) that could return the wrong
  // customer (see project_ws_listener_correlation_bug.md). Read back via
  // /v3/audit/original-customer (documentAuditTrail.ts::getOriginalCustomer).
  // Only helps SOs created AFTER this shipped — can't backfill history.
  // Para revertir: quita el campo `details` de abajo (el resto de la
  // función es el original).
  async logAuditTrail(temporal) {
    try {
      await getInformationWithDataV3('/v3/audit/log', {
        docType: 'sales_order',
        docNo: temporal.NoOrder,
        idCompany: temporal.idCompany,
        action: this.state.isNotNewSO ? 'edited' : 'created',
        salespersonNo: temporal.Customer && temporal.Customer.SalespersonNo,
        details: {
          customerNo: temporal.Customer && temporal.Customer.CustomerNo,
          customerName: temporal.Customer && temporal.Customer.CustomerName,
        },
      })
    } catch (error) {
      console.error('logAuditTrail failed (SO itself was already saved):', error)
    }
  }

  // ═══ CUSTFIX-2026-09-16 ═══════════════════════════════════════════════
  // Wired to SalesOrderList's onOrderLoadFailed — fires when reloading an
  // existing SO detects a customer mismatch (see SalesOrderList.js). No
  // auto-retry (the user can just click the same row again); just blocks
  // with a specific message instead of silently loading the wrong customer
  // (and, as a consequence, repricing the whole order under it — see
  // componentDidUpdate's loadPricingMap() trigger below).
  // Para revertir: quita este método y los props verifyCustomerMatch/
  // onOrderLoadFailed del <SalesOrderList> de arriba.
  afterSalesOrderReloadFailed = async (salesOrderHeader, reason) => {
    if (this.ModalLoading && this.ModalLoading.current) this.ModalLoading.current.showState(false)
    await Swal.fire({
      icon: 'error',
      title: 'Unable to load this sales order',
      text: reason || 'Please make sure you are connected to the internet and try again. If the problem persists, contact Support.',
      confirmButtonText: 'OK'
    })
  }

  async createSalesOrderSync(LoadMas90) {
    console.log("CREAR CON OFFLINE")
    // Se creo offline y no tiene correlative
    await this.getNewCorrelativeSalesOrder();
    this.createSalesOrder(LoadMas90);
  }

  /**
   * Backfills cost/standardPrice/finalPrice onto the just-saved SO's detail
   * rows (migration 012), via the new v3 endpoint — a second call, AFTER
   * /sales/set/order (v2, untouched) already created the order. Never blocks
   * the save flow: if this fails, the SO itself is already safely saved, only
   * the price snapshot is missing (logged, not surfaced to the user).
   */
  async recordPriceSnapshot(temporal) {
    try {
      const lines = (temporal.Detail || [])
        .filter((line) => line.Visible !== 0)
        .map((line) => ({
          itemCode: line.itemCode,
          costAtSale: (line.costAtSale !== undefined && line.costAtSale !== null) ? line.costAtSale : null,
          standardPriceAtSale: (line.standardPriceAtSale !== undefined && line.standardPriceAtSale !== null) ? line.standardPriceAtSale : null,
          finalPrice: (line.finalPrice !== undefined && line.finalPrice !== null) ? line.finalPrice
            : (line.UnitPrice !== undefined && line.UnitPrice !== null) ? line.UnitPrice : null,
        }))
      if (lines.length === 0) return
      await getInformationWithDataV3('/v3/pricing/record-sale', {
        orderNo: temporal.NoOrder,
        idCompany: temporal.idCompany,
        lines,
      })
    } catch (error) {
      console.error('recordPriceSnapshot failed (SO itself was already saved):', error)
    }
  }

  /**
   * verifySalesOrderQueued (2026-09-09, Mayaland only for now — client-
   * reported: salespeople on tablets with weak field signal sometimes see
   * the "saved" PDF even though the order never made it into the queue
   * system, leaving a manual support ticket ("buscar la SO y volverle a dar
   * guardar") as the only way anyone notices). Independent RDS re-check —
   * does NOT just trust that the /sales/set/order response reached this
   * tablet intact, actually re-queries whether the queue_log row that
   * save's createQueueLog call was supposed to write is really there. See
   * api-portal-manager's queueMonitor.ts getByRequestId + createQueueLog.ts
   * for the backend half of this (createQueueLog used to swallow a failed
   * INSERT silently — fixed alongside this).
   */
  async verifySalesOrderQueued(requestId) {
    try {
      const resp = await getInformationWithDataV3('/v3/queue/by-request-id', { requestId })
      return !!(resp && resp.status && resp.status.code === 1 && resp.data && resp.data.found)
    } catch (error) {
      console.error('verifySalesOrderQueued failed:', error)
      return false
    }
  }

  /**
   * showQueueVerificationFailedAlert (2026-09-09) — client's explicit ask:
   * "Retry" needs to be first/highlighted and "Cancel" deliberately muted,
   * because field users click by button position/color, not by reading.
   * Returns true if the user chose to retry, false if they cancelled.
   */
  async showQueueVerificationFailedAlert() {
    const result = await Swal.fire({
      title: 'Connection problem',
      text: "We couldn't confirm this order was saved. Please check your connection and try again.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Retry',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#2563EB',
      reverseButtons: false,
      allowOutsideClick: false,
      didOpen: () => {
        const cancelBtn = Swal.getCancelButton()
        if (cancelBtn) {
          cancelBtn.style.background = '#F1F5F9'
          cancelBtn.style.color = '#94A3B8'
          cancelBtn.style.boxShadow = 'none'
          cancelBtn.style.border = '1px solid #E2E8F0'
          cancelBtn.style.fontWeight = '400'
        }
      },
    })
    return result.isConfirmed
  }

  /**
   * "Never lose a sales order" (2026-09-16, client's ask) — adapted from
   * InvoiceV3.js's validateAndOpenPrint()/checkInvoicePersistedCorrectly().
   * Called right after /sales/set/order reports success (and, for
   * Mayaland, after the queue-verification step above already passed) —
   * double-checks the order actually landed correctly server-side before
   * showing the PDF, same "the backend answered OK but the write may not
   * have actually finished yet" gap InvoiceV3.js hit with /invoice/set's
   * fire-and-forget MAS90 send (see that file's checkInvoicePersistedCorrectly
   * comment). Applies to BOTH companies — Altitude has no queue_log
   * equivalent to lean on yet, so this is its only such safety net today.
   *
   * Excluded entirely (falls straight through to the exact pre-2026-09-16
   * behavior, SaveAndPrint() called immediately) when the feature flag is
   * off, or the CURRENT session's salesperson is in
   * SALES_ORDER_PERSISTENCE_CHECK_EXCLUDED_SALESPERSONS — starting with
   * just 'AM' while this rolls out gradually.
   *
   * Retries automatically (client's explicit ask — "con todo y timeouts
   * para hacer sus retry"): up to 2 attempts, waiting 5s then 8s before
   * each check, in case the first check simply ran before MAS90/the mirror
   * tables caught up. Only shows an error — asking the user to retry Save
   * and Print by hand, or fall back to contacting IT — if BOTH attempts
   * come back invalid.
   */
  async validateAndPrintSalesOrder(temporal) {
    const salesPerson = getValueCookie('SalesPerson')
    if (!ENABLE_SALES_ORDER_PERSISTENCE_CHECK || SALES_ORDER_PERSISTENCE_CHECK_EXCLUDED_SALESPERSONS.includes(salesPerson)) {
      await this.SaveAndPrint()
      return true
    }

    const salesOrderNo = temporal.NoOrder
    const savedProducts = temporal.Detail
    // One initial check + one retry, each waiting longer than the last —
    // giving MAS90/the mirror tables more room to catch up if the first
    // attempt was simply too early.
    const waits = [5000, 8000]
    let isValid = false

    for (let attempt = 0; attempt < waits.length; attempt++) {
      if (this.ModalLoading.current) {
        this.ModalLoading.current.showState(true, attempt === 0 ? 'Validating the information' : `Retrying validation (attempt ${attempt + 1} of ${waits.length})`)
      }
      await new Promise((resolve) => setTimeout(resolve, waits[attempt]))
      if (this.ModalLoading.current) {
        this.ModalLoading.current.showState(true, 'Validating sales order was saved correctly')
      }
      isValid = await this.checkSalesOrderPersistedCorrectly(salesOrderNo, savedProducts)
      if (isValid) break
    }

    if (this.ModalLoading.current) this.ModalLoading.current.showState(false)

    if (isValid) {
      await this.SaveAndPrint()
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Attention',
        text: 'This sales order could not be confirmed as saved. Please try Save and Print again. If the problem persists, contact IT Support.',
        confirmButtonText: 'OK'
      })
    }
    return isValid
  }

  /**
   * The actual header+detail check validateAndPrintSalesOrder() runs —
   * mirrors InvoiceV3.js's checkInvoicePersistedCorrectly() field-for-field
   * logic (whitespace/type-tolerant itemCode match, numeric-tolerance
   * qty/price compare, no strict line-count requirement), adapted to Sales
   * Order's own endpoints/field names:
   *   - /sales/get/header: same params SalesOrderList.js's own
   *     getSalesOrderHeader() uses, matched by SalesOrderNo.
   *   - /sales/get/detail: same params/shape SalesOrderList.js's own
   *     getSalesOrder() uses (Tabla1 = pending, Tabla2 = already
   *     shipped/picked — a line moves from one to the other, never
   *     duplicated, so both need checking); compared against
   *     quantityOrdered/UnitPrice (what this page actually sends, unlike
   *     Invoice's quantityShipped).
   * Read-only — never touches Products/SalesOrder state. Any fetch failure
   * or unexpected shape is treated as "not valid" (fails closed).
   */
  async checkSalesOrderPersistedCorrectly(salesOrderNo, savedProducts) {
    try {
      const idCompany = Number(getValueCookie('CompanyId'))
      const headerData = {
        SalespersonNo: getValueCookie('SalesPerson'),
        idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : idCompany,
      }
      const headerResp = await getInformationWithData('/sales/get/header', headerData)
      if (!headerResp || !headerResp.status || headerResp.status.code !== 1 || !Array.isArray(headerResp.data)) return false
      if (getIndexElement(headerResp.data, 'SalesOrderNo', salesOrderNo) === -1) return false

      const detailData = {
        SalesOrderNo: salesOrderNo,
        OrderNo: salesOrderNo,
        CustomerNo: this.state.SalesOrder.Customer.CustomerNo,
        username: getValueCookie('userName'),
        company: getValueCookie('Company'),
        idCompany,
        idcompany: getValueCookie('CompanyId'),
        Mode: true,
        InvoiceType: 1,
        Status: -1,
      }
      const detailResp = await getInformationWithData('/sales/get/detail', detailData)
      if (!detailResp || !detailResp.status || detailResp.status.code !== 1 || !detailResp.data) return false

      const detailLines = [
        ...(detailResp.data.Tabla1 || []),
        ...(detailResp.data.Tabla2 || []),
      ]

      const normalizeCode = (code) => (code || '').toString().trim().toUpperCase()
      const expected = (savedProducts || []).filter((p) => p.Visible === 1)
      const mismatches = []

      for (const p of expected) {
        const wanted = normalizeCode(p.itemCode)
        const match = detailLines.find((d) => normalizeCode(d.ItemCode) === wanted)
        if (!match) {
          mismatches.push({ itemCode: p.itemCode, reason: 'not found in /sales/get/detail' })
          continue
        }
        if (Math.abs(Number(match.QuantityOrdered) - Number(p.quantityOrdered)) > 0.001) {
          mismatches.push({ itemCode: p.itemCode, reason: `quantityOrdered ${p.quantityOrdered} vs detail ${match.QuantityOrdered}` })
          continue
        }
        if (Math.abs(Number(match.UnitPrice) - Number(p.UnitPrice)) > 0.01) {
          mismatches.push({ itemCode: p.itemCode, reason: `UnitPrice ${p.UnitPrice} vs detail ${match.UnitPrice}` })
        }
      }

      if (mismatches.length > 0) {
        // TEMPORARY DEBUG (2026-09-16) — remove once QA on this validation
        // is done (search "TEMPORARY DEBUG" in this file). Reports exactly
        // which line(s) tripped the check and why.
        console.group('%c[DEBUG] Sales Order persistence check — mismatch(es) found', 'color:#dc2626;font-weight:bold;')
        console.log('SalesOrderNo:', salesOrderNo)
        console.table(mismatches)
        console.groupEnd()
        return false
      }
      return true
    } catch (error) {
      console.error('checkSalesOrderPersistedCorrectly failed:', error)
      return false
    }
  }

  /**
   * performSalesOrderSave (2026-09-09) — extracted from createSalesOrder's
   * two near-identical inline try/finally blocks (the normal flow and
   * Altitude's margin-confirmation flow) so the verification/retry logic
   * below only has to be written once. A `while` loop, not recursion — a
   * retry re-enters the SAME try/finally on the next iteration instead of
   * calling itself from inside its own finally-guarded scope, which would
   * otherwise let the outer call's `finally` clear isSaving/onbeforeunload
   * out from under an in-flight retry.
   *
   * Order changed here (client's ask): traceability (logAuditTrail) now
   * runs BEFORE the PDF/success alert, not after — and a new queue-
   * verification step runs right after it, still before the PDF, so a
   * salesperson never sees "saved successfully" for an order that isn't
   * actually durably queued. Mayaland-only for now — Altitude still saves
   * via a live MAS90 WebSocket send with no queue_log row to verify against
   * (a separate, larger migration, planned but not started).
   */
  // SONUMGUARD-2026-09-25 — root-cause fix for the SO-number-collision bug
  // (NoOrder assigned once from an RDS counter when the order is started,
  // never re-checked against Sage before the real save — see
  // soNumberGuard.ts's header comment for the two real incidents this
  // already caused, PM69901/AL65252). Called right before /sales/set/order.
  // Never throws — if the check itself fails (network hiccup, backend not
  // yet deployed), it reports "no collision" so the save proceeds exactly
  // as it always has.
  async verifyOrderNumberBeforeSave(temporal) {
    try {
      const idCompany = getValueCookie('CompanyId') === '6' ? 6 : 3
      const customerNo = temporal.Customer && temporal.Customer.CustomerNo ? temporal.Customer.CustomerNo : ''
      const response = await getInformationWithDataV3('/v3/salesorder/verify-number-before-save', {
        idCompany, noOrder: temporal.NoOrder, customerNo,
      })
      if (response && response.status && response.status.code === 1 && response.data) {
        return response.data
      }
      return { collision: false, noOrderToUse: temporal.NoOrder }
    } catch (e) {
      return { collision: false, noOrderToUse: temporal.NoOrder }
    }
  }

  async performSalesOrderSave(temporal, LoadMas90) {
    // ═══ CUSTFIX-2026-09-16 ═══════════════════════════════════════════════
    // Confirmado por Aaron (el otro programador) 2026-09-16: SalesOrder.js
    // (v1/v2) siempre ha llamado a /store/json (INSERT en la tabla
    // create_csv) ANTES de /sales/set/order, como respaldo del payload
    // completo — InvoiceV3.js YA lo hace igual (línea ~1342). SalesOrderV3.js
    // nunca lo llamaba, así que ninguna SO creada desde SO V3 (Mayaland NI
    // Altitude) queda en create_csv — Aaron reportó que por esto el
    // mecanismo de retry que depende de esa tabla no encuentra nada para
    // reintentar. `temporal` aquí ya trae exactamente los mismos campos que
    // SalesOrder.js le agrega antes de su propio /store/json (idCompany,
    // username, company, OrderType, MAS90Status, Packing) — mismo payload,
    // mismo momento (antes del envío real), solo que ahora también en V3.
    // saveJsonData() nunca lanza excepción (atrapa su propio error), como en
    // los otros dos call sites — no bloquea el guardado si esto falla.
    // Para revertir: borra esta línea y el import de saveJsonData arriba.
    await saveJsonData('/store/json', temporal)
    // ═══ CUSTFIX-2026-09-16 (fin) ═════════════════════════════════════════
    // SOMONITOR-2026-09-23: one-line, side-effect-only notification for the isolated
    // SOMonitorButton component (does not read this file, only listens for this event) —
    // same pattern as INVMONITOR-2026-09-23 in InvoiceV3.js. Never awaited, never blocks
    // this save flow if it fails for any reason.
    try {
      window.dispatchEvent(new CustomEvent('so-monitor:new-order', {
        detail: { orderNo: temporal.NoOrder, idCompany: temporal.idCompany, userName: temporal.username }
      }))
    } catch (e) { /* no-op — must never block the real save */ }
    // eslint-disable-next-line no-constant-condition
    while (true) {
      this.setState({ isSaving: true });
      window.onbeforeunload = () => 'Your Sales Order is being saved. Please do not close or reload this page.';
      try {
        // SONUMGUARD-2026-09-25 — see verifyOrderNumberBeforeSave() above.
        const numberCheck = await this.verifyOrderNumberBeforeSave(temporal)
        if (numberCheck.collision) {
          const oldNoOrder = temporal.NoOrder
          temporal.NoOrder = numberCheck.noOrderToUse
          this.setState({ SalesOrder: temporal })
          Swal.fire({
            toast: true, position: 'top-end', icon: 'warning',
            title: 'Order number changed',
            html: `<b>${oldNoOrder}</b> was already used by another customer in Sage.<br/>New order number: <b>${numberCheck.noOrderToUse}</b> — your printed order will show this new number.`,
            showConfirmButton: false, timer: 8000, timerProgressBar: true,
          })
        } else if (!numberCheck.checkFailed) {
          Swal.fire({
            toast: true, position: 'top-end', icon: 'success',
            title: `Order number ${temporal.NoOrder} verified available`,
            showConfirmButton: false, timer: 1800,
          })
        }

        const result = await create_Delete_Update_Information('/sales/set/order', temporal)
        if (result.status.code === 1) {
          this.setState({ ConfirmSave: this.state.Products.length })
          await this.dedupeOrderOnServer(temporal)
          await this.recordPriceSnapshot(temporal)
          await this.logAuditTrail(temporal)

          const isMayaland = getValueCookie('CompanyId') !== '6'
          const alreadyProcessed = !!(result.alreadyProcessed || (result.data && result.data.alreadyProcessed))
          const requestId = result.data && result.data.requestId

          let verified = true
          if (isMayaland && !alreadyProcessed) {
            // 2026-09-15, URGENT client-reported incident — this alert was firing
            // on EVERY save for EVERY user, success or not. Root cause: the
            // backend deploy that returns `requestId` (my_controllers/sales.ts)
            // never went out alongside this frontend change, so requestId was
            // always undefined here, and a missing requestId was being treated
            // as "verification failed" instead of "can't verify yet." Until the
            // backend is confirmed deployed, a missing requestId now just skips
            // the check silently (old behavior) instead of alarming everyone.
            if (requestId) {
              verified = await this.verifySalesOrderQueued(requestId)
            } else {
              console.warn('[SalesOrderV3] No requestId on save response — skipping queue verification (backend not yet updated to return it?)')
            }
          }

          if (!verified) {
            const shouldRetry = await this.showQueueVerificationFailedAlert()
            if (shouldRetry) continue
            return
          }

          await confirmCloseAlert('correct', 'The order was saved successfully!')
          // 2026-09-17 fix (client-reported) — validateAndPrintSalesOrder()'s
          // return value was being ignored, so createSalesOrder() always saw
          // saveSucceeded = true even when the persistence check below it
          // failed. That set enableEdit = true (see createSalesOrder()),
          // which HIDES the Save and Print button (hidden={enableEdit}) —
          // leaving the user with the "could not be confirmed, try again"
          // message but no button left to actually try again with. /sales/
          // set/order itself DID succeed at this point regardless (that's
          // already been confirmed above), so the cache clear and Mayaland
          // price sync below still always run — only the RETURN value now
          // reflects whether the extra persistence check passed, so the
          // button only disappears once a save is actually confirmed good.
          const persistedOk = await this.validateAndPrintSalesOrder(temporal)
          localStorage.removeItem('SalesOrderSaveV3')
          if (getValueCookie('CompanyId') === '6') {
            // await this.updateCompanyPrices(temporal)
            this.updateMayalandSO(temporal)
          }
          return persistedOk
        } else {
          confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')
          return false
        }
      } finally {
        this.setState({ isSaving: false });
        window.onbeforeunload = null;
      }
    }
  }

  async createSalesOrder(LoadMas90) {
    // Synchronous re-entrancy guard — this.state.isSaving is only set INSIDE
    // the Swal confirmation callback below, which is async, so it does
    // nothing to stop this method itself from being invoked twice in quick
    // succession (double-click/double-tap before the first render commits).
    // This plain instance field is checked immediately, before Swal even
    // opens. Root of the client's duplicated-order report (AL64684) is
    // suspected to be exactly this kind of double-submit — see
    // salesOrderIntegrity.ts for the matching server-side safety net.
    if (this._savingInProgress) return
    this._savingInProgress = true

    // Duplicate-line validation (2026-08-19) — before anything else, so the
    // Swal summary below and AsignLineSequence() both see the cleaned list.
    // Mutates the same array in place (existing convention in this file, see
    // onTarget) so this.state.Products reflects it immediately, not just
    // after the next render.
    const products = this.state.Products
    const { cleaned, removedCodes } = this.removeDuplicateProducts(products)
    if (removedCodes.length > 0) {
      products.length = 0
      products.push(...cleaned)
      this.setState({ Products: products })
      console.warn('[SalesOrderV3] Duplicate line items removed before save:', removedCodes)
      await confirmCloseAlert('incorrect', `Se detectaron productos duplicados y se eliminó la fila repetida de: ${removedCodes.join(', ')}. Revisa el carrito antes de confirmar.`)
    }

    Swal.fire({
      title: 'Are you sure to save this order?',
      text: "",
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Yes, please',
      cancelButtonText: 'No, cancel!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const temporal = JSON.parse(JSON.stringify(this.state.SalesOrder))
        temporal.Detail = this.AsignLineSequence();
        temporal.idCompany = getValueCookie('CompanyId');
        temporal.username = getValueCookie('userName');
        temporal.company = getValueCookie('Company');
        temporal.OrderType = 'SalesOrder';
        temporal.MAS90Status = LoadMas90;
        temporal.Packing = this.state.selectedPacking + ";" + this.state.selectedWeight;

        // 2026-09-09, client-reported — after cancelling the new queue-
        // verification retry prompt, the whole form locked (Save button
        // gone, every field disabled) and only a page reload recovered it.
        // Root cause: the enableEdit=true below ran unconditionally after
        // ANY save attempt, success or not — pre-existing bug (a hard
        // failure had the exact same problem before today), just far more
        // reachable now that cancelling a retry is a normal, expected user
        // action instead of a rare hard error. Defaults to true so every
        // OTHER branch below (packing/weight missing, the un-awaited
        // Altitude confirmMargin path) keeps its exact prior behavior —
        // only the Mayaland save path now actually reports whether it
        // succeeded.
        let saveSucceeded = true

        if (getValueCookie('CompanyId') !== '6' || (getValueCookie('CompanyId') === '6' && !this.state.confirmMargin)) {

          if ((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption) || getValueCookie('CompanyId') === '6') {
            if (this.state.NotZeroUnitPrice) {
              saveSucceeded = await this.performSalesOrderSave(temporal, LoadMas90)
            } else {
              Swal.fire({
                title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'No, cancel!',
              })
            }
          } else {
            if (!this.state.SalesOrder.Packing) {
              Swal.fire({
                title: 'You need select a Type of Packing to Save this Sales Order!',
                text: "",
                icon: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showCancelButton: false,
                confirmButtonText: 'Ok'
              })
            } else {
              Swal.fire({
                title: 'You need select if the order are Weighed or No need to be Weighed',
                text: "",
                icon: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showCancelButton: false,
                confirmButtonText: 'Ok'
              })
            }
          }
        } else {
          Swal.fire({
            title: 'Some products have Problem with the Unit Tracking.\nDo you like to continue?',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Yes, please',
            cancelButtonText: 'No, cancel!',
          }).then(async (result) => {
            if (result.isConfirmed) {
              if (this.state.NotZeroUnitPrice) {
                await this.performSalesOrderSave(temporal, LoadMas90)
              } else {
                Swal.fire({
                  title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                  text: "",
                  icon: 'warning',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                })
              }
            }
          })
        }

        if (saveSucceeded && (this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption)) {
          this.setState({ enableEdit: true })
        }

        if (saveSucceeded && getValueCookie('CompanyId') === '6') {
          this.setState({ enableEdit: true })
        }

        // Clear SO cache
        // this.clearSalesOrderCache();
      }
    }).finally(() => {
      this._savingInProgress = false
    })
  }

  // Validate cookies
  checkSessionOrRedirect() {
    const companyId = getValueCookie('CompanyId');
    const userName = getValueCookie('userName');

    if (!companyId || !userName) {
      window.location.href = '/login';
      return false;
    }
    return true;
  }

  componentDidMount() {
    // Validate cookie
    if (!this.checkSessionOrRedirect()) return;

    if (localStorage.getItem('SalesOrderSaveV3')) {
      // Get added products
      let infoRec = JSON.parse(localStorage.getItem('SalesOrderSaveV3'));

      if (infoRec) {
        // Duplicate-line validation on load (2026-08-19) — a cached SO from
        // before CatalogueV3/SearchUPCV3's in-flight locks (or their shared
        // race window) could have a duplicate baked in.
        const cleanedProducts = this.validateNoDuplicateProducts(infoRec.Products || [])
        this.setState({ Products: cleanedProducts, SalesOrder: infoRec.SalesOrder })
      }

      if (infoRec.SalesOrder.Customer.CustomerNo === '0016027' && getValueCookie('CompanyId') !== '6') {
        this.setState({ isMayalandOrder: false })
      }
    }
    window.addEventListener('storage', this.handleStorageChange);
    if (getValueCookie('CompanyId') === '6') {
      // this.getItemList();
    }

    // Carga la sales order desde cache
    this.loadSalesOrderFromCache();
    // Toma la huella del estado inicial, por si no hay cache
    this.__prevSOSerialized = JSON.stringify(this.state.SalesOrder);

    // OFFLINE-2026-09-29 — warm the offline catalog/customer cache as soon as
    // this page loads, not only when the Catalogue modal is opened. That was
    // the ONLY trigger before (CatalogueV3.js's open()) — a salesperson who
    // opens Customer List first, before ever opening the product catalog,
    // hit an empty cache and saw zero customers offline (client-reported,
    // 2026-09-29). runOfflineSync() no-ops on its own if there's no signal.
    this.runOfflineSync()

    // LONGDESC-2026-10-01 — background load, same reasoning as InvoiceV3.js's
    // own call: the cart table has no item descriptions to show yet either
    // way at mount time (Products is still empty/loading), so there's no
    // reason to block on a potentially multi-page fetch.
    this.fetchCatalogV3()
    // Tiered customer pricing (2026-08-19) — see componentDidUpdate below for
    // why this can't just compare prevState.
    this.__prevCustomerNo = this.state.SalesOrder.Customer.CustomerNo;

    // Handle online / offline
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);

    // Standardized pricing (2026-08) — load once per session.
    this.loadPricingMap();
  }

  componentDidUpdate(prevProps, prevState) {
    // Standardized pricing (2026-08) — safety net for any cart item that
    // somehow arrived unpriced (idempotent via _pricingApplied, see
    // applyStandardPricing header comment).
    if (this.state.Products.some((item) => !item._pricingApplied)) {
      this.applyStandardPricing();
    }

    // Tiered customer pricing (2026-08-19) — the price table is per-customer
    // (level1/2/3Price), so a customer change means the whole pricingMap (and
    // any already-priced cart lines) is stale and needs reloading. Can't
    // compare prevState.SalesOrder.Customer.CustomerNo here: CustomerListV2.js
    // (v2, shared, not touched) picks a customer by mutating
    // Father.state.SalesOrder IN PLACE before calling setState, so
    // prevState.SalesOrder and this.state.SalesOrder end up being the exact
    // same object reference — that comparison silently never fires (confirmed
    // 2026-08-19: the label only updated after a full page reload). A plain
    // instance field, updated here every render, isn't affected by that
    // mutation and reflects the real value.
    const currCustomerNo = this.state.SalesOrder.Customer.CustomerNo
    if (currCustomerNo !== this.__prevCustomerNo) {
      this.__prevCustomerNo = currCustomerNo;
      this.loadPricingMap();
    }

    // Detecta cambios en SalesOrder (comparación por serialización)
    try {
      const curr = JSON.stringify(this.state.SalesOrder);
      if (curr !== this.__prevSOSerialized) {
        this.__prevSOSerialized = curr;
        this.scheduleSaveSalesOrder();
      }
    } catch (err) {
      // si algo raro hay en el estado, evita romper la UI
      console.error('componentDidUpdate compare failed:', err);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
    // Limpiar cache de la sales order
    clearTimeout(this.__soSaveTimer);
    // Handle online / offline
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  }

  // Auto sabe sales order changes
  AutoSave() {
    localStorage.setItem('SalesOrderSaveV3', JSON.stringify(this.state));
  }

  TypeInLetters(type) {
    if (type === 'S') {
      return 'Standard'
    } else {
      return 'Quote'
    }
  }

  handleModalOpen = (modal) => {
    this.setState({ [modal]: true })
  }

  handleModalClose = (modal) => {
    this.setState({ [modal]: false })
  }

  handleStorageChange = async (event) => {
    if (event.key === 'SalesOrderSaveV3') {
      let infoRec = JSON.parse(localStorage.getItem('SalesOrderSaveV3'));
      if (infoRec) {
        if (infoRec.SalesOrder.NoOrder === this.state.SalesOrder.NoOrder) {
          // Silent dedupe (no alert — this fires on every cross-tab autosave
          // sync, would spam the user). The other tab's own load/save path
          // already validates and alerts if it finds anything.
          const { cleaned } = this.removeDuplicateProducts(infoRec.Products || [])
          await this.setState({ Products: cleaned, SalesOrder: infoRec.SalesOrder })
          await this.refreshInputs()
        }
      }
    }
  }

  getTotalBalance() {
    let currentBalance = 0

    this.state.Balance.SalespersonInvoices.forEach(line => {
      currentBalance += Number(line.Balance)
    });

    const temporal = this.state.Balance
    temporal.TotalBalance = currentBalance
    this.setState({ Balance: temporal })
  }

  async getDetailBalance(LineBalance) {

    const data = {
      idCompany: Number(getValueCookie('CompanyId')),
      InvoiceNo: LineBalance.InvoiceNo
    }
    this.ModalLoading.current.showState(true);
    const result = await getInformationWithData('/invoice/history/getInvoicePayment', data)
    if (result.status.code === 1) {
      const temporal = this.state.Balance
      temporal.Detail = result.data
      temporal.SelectedInvoice = LineBalance.InvoiceNo
      this.setState({ Balance: temporal })
    }
    this.ModalLoading.current.showState(false);
  }

  validationNewSalesOrder() {
    if (this.state.Products.length !== this.state.ConfirmSave) {
      Swal.fire({
        title: 'Are you sure to Start a new Sales Order, you have a Sales Order open and unsave?',
        icon: 'info',
        showDenyButton: true,
        confirmButtonText: `Yes, I'm sure.`,
        denyButtonText: `Not`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.getNewCorrelativeSalesOrder();
        }
      })
    } else {
      this.getNewCorrelativeSalesOrder();
    }

    // Set cache for new SO status
    localStorage.setItem('isNotNewSOV3', false);
    // Update state
    this.setState({ isNotNewSO: false, newSalesOrder: true });
  }

  onChangeSelects = async (e, id) => {
    const temporal = this.state.SalesOrder
    switch (id) {
      case "Warehouse":
        temporal.Warehouse = e.value;
        this.setState({ SalesOrder: temporal, selectedWarehouse: e.value });
        this.changePriceLevel(e.value);
        break;
      case "Packing":
        temporal.Packing = e.value;
        this.setState({ SalesOrder: temporal, selectedPacking: e.value });
        break;
      case "Weight":
        temporal.WeightOption = e.value;
        this.setState({ SalesOrder: temporal, selectedWeight: e.value });
        break;
      default:
        break;
    }
  }

  changePriceLevel(id) {
    const temporal = this.state.SalesOrder
    switch (id) {
      case "003":
        temporal.Customer.PriceLevel = '4'
        this.setState({ SalesOrder: temporal })
        break;
      case "000":
        temporal.Customer.PriceLevel = '3'
        this.setState({ SalesOrder: temporal })
        break;

      default:
        break;
    }
  }

  async OnlySaveSO() {
    const temporal = this.state.SalesOrder
    temporal.Detail = this.AsignLineSequence()
    temporal.idCompany = getValueCookie('CompanyId')
    temporal.username = getValueCookie('userName')
    temporal.company = getValueCookie('Company')
    temporal.OrderType = 'SalesOrder'
    await create_Delete_Update_Information('/sales/set/order', temporal)
  }

  async TemporalSaveSystem() {
    const temporal = this.state.SalesOrder
    temporal.Detail = this.AsignLineSequence()
    temporal.idCompany = getValueCookie('CompanyId')
    temporal.username = getValueCookie('userName')
    temporal.company = getValueCookie('Company')
    temporal.OrderType = 'SalesOrder'
    if (temporal.idCompany === '6') {
      await create_Delete_Update_Information('/sales/post/savetemporal', temporal)
    }
  }

  async SaveAndPrint() {
    let button = document.getElementById('SalesOrderPrint')
    if (button) {
      button.click()
    }
  }

  disable() {
    this.setState({ disable: true })
  }

  render() {
    const { isOnline, wasOffline, lastCatalogSyncCount, lastCustomersSyncCount } = this.state;
    var syncCustomersStatus = this.state.syncCustomersStatus; // 'started' | 'done' | 'pending'
    var syncItemsStatus = this.state.syncItemsStatus;         // 'started' | 'done' | 'pending'

    // color del boton del FAB
    var allDone = isOnline && syncCustomersStatus === 'done' && syncItemsStatus === 'done';
    var anyStarted = syncCustomersStatus === 'started' || syncItemsStatus === 'started';
    var dotColor = allDone ? '#10b981' : (isOnline ? (anyStarted ? '#f59e0b' : '#6b7280') : '#ef4444');

    return (
      <div>
        {/* TABLEFONTBOOST-2026-10-01 — floating (fixed), next to the offline
            sync FAB per client feedback ("lo pondria arriba o floante a un
            lado del boton offline"). Kept OUTSIDE the zoomed wrapper below
            (sibling, not descendant) so it never grows/shrinks with the
            zoom it controls. .fab-sync is bottom:20px/right:20px, 52px wide
            — this sits immediately to its left on the same row. */}
        <TableFontSizeControl scale={this.state.tableFontScale} onChange={this.setTableFontScale}
          style={{ position: 'fixed', bottom: '20px', right: '84px', zIndex: 9999 }} />
        <div id="GeneralPages" className="page sales-order-v3-page" style={{ zoom: this.state.tableFontScale }}>
          {/* Main menu */}
          <Menu Refresh={this.state.Refresh} Father={this} />

          <div className="container-fluid generalContainer contPrincipal" id="actualPage">
            {/* Loading modal */}
            <LoadingWindow ref={this.ModalLoading} />

            {/* Hero */}
            <div className='text-center my-4'>
              <h2 className='display-5 fw-bold inventory-title'>Sales Order</h2>
              <p className='lead text-muted inventory-subtitle'>Start creating or selecting an order.</p>
            </div>

            {/* FAB flotante — OFFLINE-2026-09-29: this is now the one, always-
                visible entry point for "is my offline data ready", instead of
                that only being discoverable inside the Catalogue modal
                (client-reported: "el usuario no se va a imaginar que ahi se
                descarga"). Label changed from the old generic "Sync status"
                to spell out what it actually does. */}
            <button className="fab-sync" onClick={this.toggleSyncPanel} aria-label="Offline data status">
              {isOnline ? <FiActivity /> : <FiWifiOff />}
              <span className="fab-dot" style={{ background: dotColor }} />
            </button>

            {/* Panel flotante */}
            {this.state.showSyncPanel ? (
              <div className="fab-panel">
                <h4>{isOnline ? <span><FiWifi style={{ marginRight: 6 }} />Connected</span> : <span><FiWifiOff style={{ marginRight: 6 }} />No connection</span>}</h4>
                <p style={{ fontSize: '0.78rem', opacity: 0.75, margin: '-4px 0 8px' }}>
                  Saves the product catalog and customer list on this device so you can keep building an order without signal.
                </p>

                {/* Customer */}
                <div className="sync-row" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <FiUsers />
                  <span>Customer list{lastCustomersSyncCount ? ` (${lastCustomersSyncCount})` : ''}</span>
                  {syncCustomersStatus === 'started' ? (
                    <span className="sync-badge started"><span className="spin">⟳</span> syncing…</span>
                  ) : syncCustomersStatus === 'done' ? (
                    <span className="sync-badge done">done ✓</span>
                  ) : (
                    <span className="sync-badge idle">idle</span>
                  )}
                </div>

                {/* Catalog */}
                <div className="sync-row" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <FiPackage />
                  <span>Product catalog{lastCatalogSyncCount ? ` (${lastCatalogSyncCount})` : ''}</span>
                  {syncItemsStatus === 'started' ? (
                    <span className="sync-badge started"><span className="spin">⟳</span> syncing…</span>
                  ) : syncItemsStatus === 'done' ? (
                    <span className="sync-badge done">done ✓</span>
                  ) : (
                    <span className="sync-badge idle">idle</span>
                  )}
                </div>

                <button type="button" className="btn btn-sm btn-outline-light w-100 mt-2"
                  disabled={!isOnline || anyStarted} onClick={() => this.runOfflineSync(true)}>
                  {anyStarted ? 'Syncing…' : 'Sync now for offline use'}
                </button>
              </div>
            ) : null}

            {getValueCookie('CompanyId') === '3' && this.state.SalesOrder.Customer.CustomerNo === '0016027' ?
              <div className="alert alert-primary" role="alert">
                <h4>Consultation-Only View</h4>
                <p>This order is managed by Altitude Distribution Corp.</p>
                <p>Any updates or corrections must be made directly in the respective portal. This view is for consultation purposes only.</p>
                <hr />
                <p>If you have any questions, please contact IT support.</p>
              </div>
              : null}

            {this.state.SalesOrder.status === 1 ?
              <div className="alert alert-warning" role="alert">
                <h4>Sales Order in progress</h4>
                <p>This order is in progress.</p>
                <p>Please let the warehouse personnel know about any changes. They need to refresh/reload this sales order to apply the new updates.</p>
                <hr />
                <p>If you have any questions, please contact IT support.</p>
              </div>
              : null}

            {/* Start process with new SO o Existing SO */}
            <div className='row d-flex justify-content-center pb-4'>
              <div className='col-md-10 InputText'>
                <div className="card shadow">
                  <div className="card-body">
                    <div className="flex-nowrap d-flex" style={{ marginBottom: 0, justifyContent: 'space-around' }}>
                      {/* Validate is online */}
                      {isOnline ?
                        <button type="button" onClick={() => this.validationNewSalesOrder()} className="btn blueButton btn-lg  shadow" style={{width: '45%'}}><FiCheckCircle /> New Order</button>
                        :
                        <button type="button" onClick={() => this.offlineNewOrder()} className="btn orangeButtonv2 btn-lg shadow" style={{width: '45%'}}><FiCheckCircle /> New Order (Offline)</button>
                      }

                      {/* Validate is online. CUSTFIX-2026-09-16 — SalesOrderList's verifyCustomerMatch/onOrderLoadFailed props are opt-in: only SalesOrderV3.js passes them, so SalesOrder.js/SalesOrderV2.js/PreSalesOrder.js etc. (v1/v2, congelados) are unaffected. To revert, remove these two props and the handler below. */}
                      {isOnline ?
                        <SalesOrderList disabled={false} headerName='' nombrePadre="SalesOrderListSO" Padre={this} width='45' verifyCustomerMatch={true} onOrderLoadFailed={this.afterSalesOrderReloadFailed} />
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SO general info */}
            <div className='row d-flex justify-content-center'>
              <div className='col-sm-12 col-md-10'>
                {this.state.SalesOrder && this.state.SalesOrder.NoOrder ?
                  <div className='row'>
                    <div className='col-sm-12 col-md-6'>
                      <div className='card' style={{ background: '#f1f1f1' }}>
                        <div className="card-body">
                          <div className='row'>
                            <div className='col-5 InputTextBolder text-end'><p>Order No: </p></div>
                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.NoOrder}</div>
                            <div className='col-5 InputTextBolder text-end'><p>Person No: </p></div>
                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.SalespersonNo}</div>
                            <div className='col-5 InputTextBolder text-end'><p>Price Level: </p></div>
                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.PriceLevel}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='card' style={{ background: '#f1f1f1' }}>
                        <div className="card-body">
                          <div className='col-sm-12 mb-3 d-flex justify-content-center'>
                            <div className="form-check d-flex align-items-center justify-content-center" style={{ border: '1px solid #ccc', borderRadius: 5, padding: '0px 8px 5px 8px' }}>
                              <input disabled={this.state.enableEdit} className="form-check-input textRadioButtonSize" value={'S'} onChange={this.valueRadioButton} id="SalesOrderStand" checked={this.state.SalesOrder.Type === 'S'} type="radio" name="typeSalesOrder" style={{ marginLeft: 0 }} />
                              <label className="form-check-label textRadioButtonSize InputTextBolderSimple ms-2 pt-2" htmlFor="SalesOrderStand" style={{ fontSize: '18px' }}>
                                Standard
                              </label>
                            </div>

                            {this.state.SalesOrder.Type === 'S' && this.state.isNotNewSO && this.state.status !== null ?
                              null
                              :
                              <div className="form-check d-flex align-items-center justify-content-center ms-2" style={{ border: '1px solid #ccc', borderRadius: 5, padding: '0px 8px 5px 8px' }}>
                                <input disabled={this.state.enableEdit} hidden={this.state.SalesOrder.Type === 'S' && this.state.isNotNewSO && this.state.status !== null} className="form-check-input textRadioButtonSize" value={'Q'} onChange={this.valueRadioButton} id="SalesOrderQuot" checked={this.state.SalesOrder.Type === 'Q'} type="radio" name="typeSalesOrder" style={{ marginLeft: 0 }} />
                                <label hidden={this.state.SalesOrder.Type === 'S' && this.state.isNotNewSO && this.state.status !== null} className="form-check-label textRadioButtonSize InputTextBolderSimple ms-2 pt-2" htmlFor='SalesOrderQuot' style={{ fontSize: '18px' }}>
                                  Quote
                                </label>
                              </div>
                            }
                          </div>

                          <hr />

                          <div className='col-sm-12' hidden={getValueCookie('CompanyId') === '6'}>
                            <div className='row' >
                              <div className='col-12 InputTextBolder text-start'><p>Type of Packaging: </p></div>
                              <div className='col-12 pb-3'>
                                <Select value={this.state.selectOptions1[(getIndexElement(this.state.selectOptions1, 'value', this.state.SalesOrder.Packing))]} isDisabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} className='fs-5 text-start' menuPortalTarget={document.body} menuPosition='fixed' styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={this.state.selectOptions1} onChange={(e) => this.onChangeSelects(e, "Packing")} placeholder="Select Type of Packaging" />
                              </div>
                            </div>
                          </div>

                          <hr />

                          <div className='col-sm-12' hidden={getValueCookie('CompanyId') === '6'}>
                            <div className='row' >
                              <div className='col-12 InputTextBolder text-start'><p>Need to be Weighed?</p></div>
                              <div className='col-12 pb-3'>
                                <Select value={this.state.selectOptions3[(getIndexElement(this.state.selectOptions3, 'value', this.state.SalesOrder.WeightOption))]} isDisabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} className='fs-5 text-start' menuPortalTarget={document.body} menuPosition='fixed' styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={this.state.selectOptions3} onChange={(e) => this.onChangeSelects(e, "Weight")} placeholder="Select Type of Packaging" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
              </div>
            </div>
            {/* control sale order final*/}

            {/* Customer details */}
            <div className='row pt-1 pb-2' style={{ display: this.state.SalesOrder && this.state.SalesOrder.NoOrder ? 'block' : 'none' }}>
              <div className='row d-flex justify-content-center pb-4'>
                <div className='col-md-10 InputText'>
                  <div className="card shadow">
                    <div className="card-body d-flex justify-content-center">
                      {/* Customer locked once a product has been added (2026-09-01,
                          client's ask) — the client doesn't trust the recalculation
                          a customer swap would trigger mid-order; a salesperson who
                          picked the wrong customer must start a new Sales Order
                          instead of switching customers on this one. */}
                      <CustomerListV3 disabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit || this.state.SalesOrder.status === 2 || this.state.Products.length > 0} Padre={this} />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row d-flex justify-content-center'>
                <div className='col-sm-12 col-md-10'>
                  <div className='card' style={{ background: '#f1f1f1' }}>
                    <div className="card-body">
                      <div className="row">
                        <div className='col-sm-6'>
                          <div className='row'>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Customer No: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerNo}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Name: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerName}</div>
                              </div>
                            </div>
                            {this.state.SalesOrder.Customer.CustomerNo && (
                              <div className='col-sm-12'>
                                <div className='row'>
                                  <div className='col-6 InputTextBolder text-end'><p>Price Level: </p></div>
                                  <div className='col-6 textTableSize'>
                                    <span style={{
                                      background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE',
                                      borderRadius: '999px', padding: '2px 10px', fontSize: '0.78rem', fontWeight: 700,
                                    }}>Level {this.state.customerPriceLevel}</span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Address Line: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.AddressLine1}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>City: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.City}</div>
                              </div>
                            </div>
                            <div hidden={getValueCookie('CompanyId') !== '6'} className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Unique Tracking: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.uniqueTrack}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className='row'>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Zip Code: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.ZipCode}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>State: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.State}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Telphone No: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.TelephoneNo}</div>
                              </div>
                            </div>
                            <div className='col-sm-12'>
                              <div className='row'>
                                <div className='col-6 InputTextBolder text-end'><p>Email Address: </p></div>
                                <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.EmailAddress}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* customer details final */}
            
            {/* Catalogue section */}
            <div className='row' style={{ display: this.state.SalesOrder && this.state.SalesOrder.NoOrder && this.state.SalesOrder.Customer && this.state.SalesOrder.Customer.CustomerNo ? 'block' : 'none' }}>
              <div className='d-flex justify-content-center'>
                <div className='col-sm-12 col-md-10'>

                  <div hidden={Number(getValueCookie('SubCompanyId')) !== 5}>
                    <div className="card shadow">
                      <div className="card-body">
                        <div className='col-sm-12 InputTextBolder'><p>Warehouse: </p></div>
                        <div className='col-sm-12 pb-3'>
                          <Select value={this.state.selectOptions2[(getIndexElement(this.state.selectOptions2, 'value', this.state.SalesOrder.Warehouse))]} isDisabled={false} className='fs-4 text-start' options={this.state.selectOptions2} onChange={(e) => this.onChangeSelects(e, "Warehouse")} placeholder="Select Warehouse" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card with buttons for catalogue and print */}
                  <div className='col-sm-12 pt-2'>
                    <div className="card shadow">
                      <div className="card-body">
                        <div className="input-group input-group-lg flex-nowrap justify-content-between mb-0">
                          {/* Add by item code — SearchUPCV3, RDS-only, prices from product_pricing */}
                          <SearchUPCV3 disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} Padre={this} width='50' />

                          <div className='w-50 d-flex justify-content-end align-items-center flex-row'>
                            {/* Catalogue — CatalogueV3, RDS-only, prices from product_pricing */}
                            <div className='me-2'>
                              <CatalogueV3 Padre={this} colorButton='blueButton' disabled={this.state.SalesOrder.Customer.CustomerNo === '' || this.state.enableEdit || this.state.SalesOrder.status === 2} titleButton='Open Catalogue' />
                            </div>

                            {/* Print button */}
                            {
                              isOnline?
                                MobileDisp() ?
                                  <OrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                    companyLogo={getValueCookie('DocumentsLogo')}
                                    OrderTitle="Sales Order"
                                    contactInfo={this.state.companyPrintHeader}
                                    OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                      "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                      "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                      "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                      "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                      "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                      "State:", this.state.SalesOrder.Customer.State, "", ""
                                    ]}
                                    headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                    bodyTable={this.detailToPrint()}
                                    headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                    bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                    styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                    comment={""}
                                    breakpoint={52}
                                    keysDecimalFormat={["UnitPrice", "totalCost"]}
                                    disabled={this.state.SalesOrder.Customer.CustomerNo === ''}
                                  />
                                  :
                                  <DownloadOrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                    companyLogo={getValueCookie('DocumentsLogo')}
                                    OrderTitle="Sales Order"
                                    contactInfo={this.state.companyPrintHeader}
                                    OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                      "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                      "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                      "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                      "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                      "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                      "State:", this.state.SalesOrder.Customer.State, "", ""
                                    ]}
                                    docname={this.state.SalesOrder.NoOrder}
                                    headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                    bodyTable={this.detailToPrint()}
                                    headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                    bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                    styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                    comment={""}
                                    breakpoint={52}
                                    keysDecimalFormat={["UnitPrice", "totalCost"]}
                                    disabled={this.state.SalesOrder.Customer.CustomerNo === ''}
                                  />
                              :<></>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* List of selected products section */}
            {this.state.SalesOrder && this.state.SalesOrder.NoOrder && this.state.SalesOrder.Customer && this.state.SalesOrder.Customer.CustomerNo ?
              <div className='row d-flex justify-content-center mt-4'>
                <div className='col-sm-12 col-md-10 tableFixHead'>
                  <table className='table table-striped align-middle table-hover'>
                    <thead>
                      <tr>
                        <th className='text-center'>Item  Code</th>
                        <th className='text-center'>Description</th>
                        <th className='text-center'>Quantity</th>
                        <th className='text-center'>Weight</th>
                        <th className='text-center'>Total Weight</th>
                        <th className='text-center'>Unit Price</th>
                        <th className='text-center'>Total</th>
                        <th className='text-center'></th>
                        <th className='text-center'></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.Products.map((item, i) => (
                        <tr key={i} hidden={item.Visible === 0} className={item.duplicate ? item.duplicate : (item.UnitPrice <= 0 ? 'bg-warning' : '')}>
                          <td className='text-center textTableSize'>{item.itemCode}</td>
                          <td className='text-start textTableSize'>{this.getItemLongDescription(item)}</td>
                          <td>
                            <div className="input-group  input-group-lg">
                              <input disabled={this.state.enableEdit || this.state.SalesOrder.status === 2} type="number" id={'quantityOrderedSalesOrder_' + i} min={1} defaultValue={item.quantityOrdered} onChange={(e) => this.onTarget(e, item)} className="form-control text-center inputResize" />
                            </div>
                          </td>
                          <td className='text-center textTableSize text-secondary' >{item.ShipWeight + ' lbs'}</td>
                          <td className='text-center textTableSize text-secondary'> {NumberFormat(pricesFormat(item.quantityOrdered * item.ShipWeight)) + ' lbs'}</td>
                          <td >
                            <div className="input-group input-group-lg flex-nowrap">
                              <span className="input-group-text">$</span>
                              <input disabled={this.state.enableEdit} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" />
                            </div>
                            {/* Standardized pricing (2026-08) — show a warning if this item has
                                no row in product_pricing yet. Otherwise show the customer's
                                Price Level (2026-08-21, client's ask — replaces the old "Minimum:
                                $X" display, which showed the floor instead of the actual catalog/
                                tier price and confused salespeople). The floor itself (priceFloorFor)
                                still gates checkPriceBounds() — it's just no longer shown here. */}
                            {item._noPricingConfigured ? (
                              <div style={{ fontSize: '0.7rem', color: '#991B1B', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <AiOutlineWarning /> No standard price configured
                              </div>
                            ) : (item.standardPriceAtSale !== undefined && item.standardPriceAtSale !== null) ? (
                              <div style={{ fontSize: '0.7rem', color: '#64748B', marginTop: '4px' }}>
                                Price level: ${NumberFormat(pricesFormat(item.standardPriceAtSale))}
                              </div>
                            ) : null}
                          </td>
                          <td className='text-end textTableSize text-success'> $ {NumberFormat(Number(item.totalCost).toFixed(2))}</td>
                          <td>
                            <div className="d-grid gap-1">
                              <button disabled={this.state.enableEdit || this.state.SalesOrder.status === 2} type="button" onClick={() => this.addComentary(item)} className="btn grayButton btn-lg text-wrap"> <AiOutlineComment /> </button>
                            </div>
                          </td>
                          <td>
                            <div className="d-grid gap-2">
                              <button disabled={this.state.enableEdit || this.state.SalesOrder.status === 2} type="button" onClick={() => this.removeProduct(item)} className="btn redButton btn-lg"><FiTrash /></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className='tfoot'>
                      <tr className='' style={{ background: '#79c7cc', color: 'white' }}>
                        <td></td>
                        <td className='text-center textTableSize'>Totals</td>
                        <td className='text-center textTableSize'>{NumberFormat(this.state.SalesOrder.TotalQuantityOrdered)}</td>
                        <td></td>
                        <td className='text-center textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalWeight) + ' lbs')} </td>
                        <td className='text-end textTableSize'>$</td>
                        <td className='text-end textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            : null }
            {/* products details final */}

            {/* Order save section — "Clear order" removed (2026-09-01, client's
                ask): users hit it by accident, and it's redundant with just
                starting a new Sales Order, which is now the only way to clear. */}
            {this.state.SalesOrder && this.state.SalesOrder.NoOrder && this.state.SalesOrder.Customer && this.state.SalesOrder.Customer.CustomerNo ?
              <div className='row pb-2 d-flex justify-content-center'>
                <div className='col-10'>
                  <div className="card shadow">
                    <div className="card-body d-flex justify-content-center">
                      {isOnline && !wasOffline ?
                        <button hidden={this.state.enableEdit} disabled={this.state.Products.length === 0 || this.state.isInputFocused || !this.state.isMayalandOrder || this.state.SalesOrder.status === 2 || this.state.isSaving} type="button" onClick={() => this.createSalesOrder(1)} className="btn greenButton btn-lg"><FiSave /> Save and Print</button>
                        : null}
                      {/* Was offline at least 1 time */}
                      {isOnline && wasOffline ?
                        <button hidden={this.state.enableEdit} disabled={this.state.Products.length === 0 || this.state.isInputFocused || !this.state.isMayalandOrder || this.state.SalesOrder.status === 2 || this.state.isSaving} type="button" onClick={() => this.createSalesOrderSync(1)} className="btn greenButtonv2 btn-lg"><FiCheckSquare /> Save and Print</button>
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            : null}
            {/* pdf order final */}

            {/* modal Balance inicio*/}
            <SmallModal centered={false} size={'xl'} title={'Balance: ' + this.state.SalesOrder.Customer.CustomerName} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
              <div className='row pt-2'>
                <div className='col-sm-12 pb-2'>
                  {/* <h3>Terms Code: {this.state.Balance.TermsCode}</h3> */}
                  {/* <h2 style={{ color: this.state.Balance.CustomerBalance > 0 ? '#EF4444' : '#10b981', fontWeight: 800 }}>
                    Current Balance: ${NumberFormat(pricesFormat(this.state.Balance.CustomerBalance))}
                  </h2> */}
                </div>
                {/* Balance Customer (2026-09-02, client's ask) — the
                    actually-correct list, filtered by THIS customer's own
                    CustomerNo. Kept alongside Balance Salesperson below
                    (not replacing it), per the client's explicit ask —
                    both lists, clearly titled. */}
                <div className='col-sm-12 pb-2'>
                  <h5 className='text-start mb-1'>Balance Customer</h5>
                  <p className='text-muted mb-0'><small>This customer's own open invoices only.</small></p>
                </div>
                <div className='col-sm-12 tableFixHead'>
                  <table className='table table-hover text-center'>
                    <thead className='thead'>
                      <tr className='bg-dark'>
                        <th>Invoice No</th>
                        <th>Date</th>
                        <th>Due Date</th>
                        <th>Payment Delay Days</th>
                        <th></th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.Balance.CustomerInvoices.map((element, e) => (
                          <tr className={element.InvoiceNo === this.state.Balance.SelectedInvoice ? 'bg-warning' : ''} onClick={() => this.getDetailBalance(element)} key={e}>
                            <td className='text-start'>{element.InvoiceNo}</td>
                            <td>{element.InvoiceDate}</td>
                            <td>{element.InvoiceDueDate}</td>
                            <td>{element.PaymentDelayDays}</td>
                            <td>$</td>
                            <td className='text-end' style={{ color: Number(element.Balance) > 0 ? '#EF4444' : 'inherit', fontWeight: Number(element.Balance) > 0 ? 700 : 'inherit' }}>{NumberFormat(pricesFormat(element.Balance))}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                    <tfoot className='tfoot'>
                      <tr className='table-dark'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>TOTAL:</td>
                        <td>$</td>
                        <td className='text-end' style={{ color: this.state.Balance.CustomerInvoices.reduce((sum, el) => sum + Number(el.Balance), 0) > 0 ? '#EF4444' : 'inherit', fontWeight: 800 }}>{NumberFormat(pricesFormat(this.state.Balance.CustomerInvoices.reduce((sum, el) => sum + Number(el.Balance), 0)))}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* Balance Salesperson (was the only list before 2026-09-02) —
                    informational, grouped by salesperson, may include invoices
                    from other customers assigned to the same salesperson. */}
                {/* 2026-09-02, client's ask — remove this section for now, but kept for reference. */}
                {/* 
                  <div className='col-sm-12 pb-2 pt-3'>
                    <h5 className='text-start mb-1'>Balance Salesperson {getValueCookie('SalesPerson')}</h5>
                    <p className='text-muted mb-0'><small>Informational only — every open invoice for this salesperson, may include other customers. Use Balance Customer above for this customer's own invoices.</small></p>
                  </div>
                  <div className='col-sm-12 tableFixHead'>
                    <table className='table table-hover text-center'>
                      <thead className='thead'>
                        <tr className='bg-dark'>
                          <th>Invoice No</th>
                          <th>Date</th>
                          <th>Due Date</th>
                          <th>Payment Delay Days</th>
                          <th>Sales Person</th>
                          <th></th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.Balance.SalespersonInvoices.map((element, e) => (
                            <tr className={element.InvoiceNo === this.state.Balance.SelectedInvoice ? 'bg-warning' : ''} onClick={() => this.getDetailBalance(element)} key={e}>
                              <td className='text-start'>{element.InvoiceNo}</td>
                              <td>{element.InvoiceDate}</td>
                              <td>{element.InvoiceDueDate}</td>
                              <td>{element.PaymentDelayDays}</td>
                              <td>{element.SalespersonNo}</td>
                              <td>$</td>
                              <td className='text-end' style={{ color: Number(element.Balance) > 0 ? '#EF4444' : 'inherit', fontWeight: Number(element.Balance) > 0 ? 700 : 'inherit' }}>{NumberFormat(pricesFormat(element.Balance))}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                      <tfoot className='tfoot'>
                        <tr className='table-dark'>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>TOTAL:</td>
                          <td>$</td>
                          <td className='text-end' style={{ color: this.state.Balance.TotalBalance > 0 ? '#EF4444' : 'inherit', fontWeight: 800 }}>{NumberFormat(pricesFormat(this.state.Balance.TotalBalance))}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                */}
                
                
                {/* Detail Balance */}
                  <div className='col-sm-12'>
                    <h3 className='text-start'>Detail: {this.state.Balance.SelectedInvoice}</h3>
                  </div>
                  <div className='col-sm-12 tableFixHead'>
                    <table className='table table-hover text-center'>
                      <thead className='thead'>
                        <tr>
                          <th>Invoice No</th>
                          <th>Invoice Type</th>
                          <th>Transaction Type</th>
                          <th>Transaction Date</th>
                          <th></th>
                          <th>Transaction Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.Balance.Detail.map((element, e) => (
                            <tr key={e}>
                              <td className='text-start'>{element.InvoiceNo}</td>
                              <td>{element.InvoiceType}</td>
                              <td>{element.TransactionType}</td>
                              <td>{DateFormatMAS90(element.TransactionDate)}</td>
                              <td className='text-end'>$</td>
                              <td className='text-end'>{NumberFormat(pricesFormat(element.TransactionAmt))}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                      <tfoot className='tfoot'>
                      </tfoot>
                    </table>
                  </div>
                 
                <div className='col-sm-6 pt-2'>
                  {
                    MobileDisp() ?
                      <OrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                        companyLogo={getValueCookie('DocumentsLogo')}
                        OrderTitle="Current Balance"
                        contactInfo={this.state.companyPrintHeader}
                        OrderInfo1={[
                          "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                          "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                          "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                          "Address:", this.state.SalesOrder.Customer.AddressLine1, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                          "City", this.state.SalesOrder.Customer.City, "Current Balance:", '$' + NumberFormat(pricesFormat(this.state.Balance.CustomerBalance))
                        ]}
                        headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "", "Balance"]}
                        bodyTable={this.state.Balance.CustomerInvoices}
                        headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "dolar", "Balance"]}
                        bottomInfo={["", "", "", "TOTAL", "$", NumberFormat(pricesFormat(this.state.Balance.CustomerInvoices.reduce((sum, el) => sum + Number(el.Balance), 0)))]}
                        styleColumns={["ColumnaTextoNormal2", "ColumnaTextoLargoCenter", "ColumnaTextoLargoCenter", "ColumnaTextoNormal2", "Dolar", "ColumnaPrecios"]}
                        hidden={false}
                        comment={""}
                        keysDecimalFormat={["Balance"]}
                        breakpoint={28}
                        disabled={false}
                        titleButton='Print Balance'
                      />
                      :
                      <DownloadOrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                        companyLogo={getValueCookie('DocumentsLogo')}
                        docname={'Balance ' + this.state.SalesOrder.Customer.CustomerName}
                        OrderTitle="Current Balance"
                        contactInfo={this.state.companyPrintHeader}
                        OrderInfo1={[
                          "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                          "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                          "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                          "Address:", this.state.SalesOrder.Customer.AddressLine1, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                          "City", this.state.SalesOrder.Customer.City, "Current Balance:", '$' + NumberFormat(pricesFormat(this.state.Balance.CustomerBalance))
                        ]}
                        headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "", "Balance"]}
                        bodyTable={this.state.Balance.CustomerInvoices}
                        headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "dolar", "Balance"]}
                        bottomInfo={["", "", "", "TOTAL", "$", NumberFormat(pricesFormat(this.state.Balance.CustomerInvoices.reduce((sum, el) => sum + Number(el.Balance), 0)))]}
                        styleColumns={["ColumnaTextoNormal2", "ColumnaTextoLargoCenter", "ColumnaTextoLargoCenter", "ColumnaTextoNormal2", "Dolar", "ColumnaPrecios"]}
                        hidden={false}
                        comment={""}
                        keysDecimalFormat={["Balance"]}
                        breakpoint={28}
                        disabled={false}
                        titleButton='Print Balance'
                      />
                  }
                </div>
                <div className='col-sm-6 pt-2'>
                  <div className="d-grid gap-2">
                    <button type="button" onClick={() => this.handleModalClose("showModal1")} className="btn redButton btn-lg">Close</button>
                  </div>
                </div>
              </div>
            </SmallModal>
            {/* modal Balance final*/}
          </div>
        </div>
      </div>
    )
  }
}
